<template>
    <div>
        <div v-if="product && Object.keys(product).length">
            <section class="breadcrumb-section">
                <div class="container">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <router-link to="/">Home</router-link>
                            </li>

                            <li
                                v-if="is_tshirt_24_hour"
                                class="breadcrumb-item"
                            >
                                <router-link
                                    :to="{
                                        name: 'product_list_24_tshirt',
                                        params: { product_type: 'tshirt24' }
                                    }"
                                    >24hour T-shirt</router-link
                                >
                            </li>

                            <li
                                v-else-if="product.Category"
                                class="breadcrumb-item"
                            >
                                <router-link
                                    :to="{
                                        path:
                                            '/product-list/' +
                                            productTypePath +
                                            '/' +
                                            product.Category.id
                                    }"
                                    >{{ product.Category.title }}</router-link
                                >
                            </li>

                            <li
                                class="breadcrumb-item active"
                                aria-current="page"
                            >
                                Product Details
                            </li>
                        </ol>
                    </nav>
                </div>
            </section>

            <section
                class="product_details pt_20 product_details_vue product_details_update product_details_update_v3"
            >
                <div class="container">
                    <div class="row">
                        <div class="col-md-12 col-lg-6 pr-lg-0 pro-mobile-0">
                            <div class="gallery-container">
                                <ProductZoomer
                                    :product="product"
                                    v-if="!isEmpty(images)"
                                    :base-images="images"
                                    :base-zoomer-options="zoomerOptions"
                                />
                            </div>
                            <div
                                class="share mx-auto d-flex justify-content-center align-items-center mt_30"
                            >
                                <h6 class="font_size_18 m-0">SHARE:</h6>
                                <div
                                    class="sharethis-inline-share-buttons"
                                ></div>
                                <ul class="share_item ml_16 my-0">
                                    <li>
                                        <a
                                            href="javascript:void(0);"
                                            @click="shareOnFacebook"
                                            ><img
                                                src="/maincss/images/share_fb.svg"
                                                alt="Facebook"
                                        /></a>
                                    </li>
                                    <li>
                                        <a
                                            href="javascript:void(0);"
                                            @click="shareOnTwitter"
                                            ><img
                                                src="/maincss/images/twitterx.svg"
                                                width="22px"
                                                height="22px"
                                                alt="Twitter"
                                        /></a>
                                    </li>
                                    <li>
                                        <a
                                            href="javascript:void(0);"
                                            @click="shareOnInstagram"
                                            ><img
                                                src="/maincss/images/share_instagram.svg"
                                                alt="Instagram"
                                        /></a>
                                    </li>
                                </ul>
                            </div>
                            <div class="product_detail_tabs pt-0 pb-40-bottom">
                                <div class="container">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <ul
                                                class="nav nav-tabs default_tabs"
                                                id="product_tabs"
                                                role="tablist"
                                            >
                                                <li
                                                    v-if="product.description"
                                                    class="nav-item"
                                                    role="presentation"
                                                >
                                                    <a
                                                        class="nav-link active"
                                                        id="home-tab1"
                                                        data-toggle="tab"
                                                        href="#product_details"
                                                        role="tab"
                                                        aria-controls="home"
                                                        aria-selected="true"
                                                        >Product Details</a
                                                    >
                                                </li>
                                                <!-- <li
                                                    v-if="
                                                        more_decoration_list.length >
                                                        0
                                                    "
                                                    class="nav-item"
                                                    role="presentation"
                                                >
                                                    <a
                                                        class="nav-link"
                                                        id="profile-tab1"
                                                        data-toggle="tab"
                                                        href="#decoration"
                                                        role="tab"
                                                        aria-controls="profile"
                                                        aria-selected="false"
                                                        >Decoration</a
                                                    >
                                                </li> -->

                                                <li
                                                    v-if="
                                                        otherServices.length > 0
                                                    "
                                                    class="nav-item"
                                                    role="presentation"
                                                >
                                                    <a
                                                        class="nav-link"
                                                        id="profile-tab1"
                                                        data-toggle="tab"
                                                        href="#decoration"
                                                        role="tab"
                                                        aria-controls="profile"
                                                        aria-selected="false"
                                                        >Other Services</a
                                                    >
                                                </li>
                                                <li
                                                    v-if="
                                                        product.Brand &&
                                                        product.Brand
                                                            .size_chart_image
                                                    "
                                                    class="nav-item"
                                                    role="presentation"
                                                >
                                                    <a
                                                        class="nav-link"
                                                        id="contact-tab1"
                                                        data-toggle="tab"
                                                        href="#size_chart"
                                                        role="tab"
                                                        aria-controls="contact"
                                                        aria-selected="false"
                                                        >Size Chart</a
                                                    >
                                                </li>
                                            </ul>
                                            <div
                                                class="tab-content"
                                                id="myTabContent"
                                            >
                                                <div
                                                    class="tab-pane fade show active"
                                                    v-if="product.description"
                                                    id="product_details"
                                                    role="tabpanel"
                                                    aria-labelledby="home-tab1"
                                                >
                                                    <h4
                                                        class="font_size_20 mb-0"
                                                    >
                                                        Product Description
                                                    </h4>
                                                    <h5
                                                        class="font_size_20 mb-0 mt_28"
                                                        v-html="
                                                            product.description
                                                        "
                                                    ></h5>
                                                    <br />
                                                    <div
                                                        v-if="
                                                            product.feature_description
                                                        "
                                                    >
                                                        <h4
                                                            class="font_size_20 mb-0"
                                                        >
                                                            Features
                                                        </h4>
                                                        <h5
                                                            class="font_size_20 mb-0 mt_28"
                                                            v-html="
                                                                product.feature_description
                                                            "
                                                        ></h5>
                                                    </div>
                                                    <a
                                                        v-if="
                                                            product.product_specification_sheet_url
                                                        "
                                                        :href="
                                                            product.product_specification_sheet_url
                                                        "
                                                        target="_blank"
                                                        >Product Spec Sheet</a
                                                    >
                                                </div>

                                                <!-- <div
                                                    class="tab-pane fade"
                                                    v-if="
                                                        more_decoration_list.length >
                                                        0
                                                    "
                                                    id="decoration"
                                                    role="tabpanel"
                                                    aria-labelledby="profile-tab1"
                                                >
                                                    <div class="tabs_table">
                                                        <div
                                                            class="available_color_columns no_borders_custom decoration_table_product_detais_custom"
                                                        >
                                                            <table
                                                                class="table table-bordered"
                                                            >
                                                                <thead>
                                                                    <tr>
                                                                        <th>
                                                                            Name
                                                                        </th>
                                                                        <th
                                                                            width="700"
                                                                        >
                                                                            Description
                                                                        </th>
                                                                        <th>
                                                                            Decoration
                                                                            Type
                                                                        </th>
                                                                        <th>
                                                                            Price
                                                                        </th>
                                                                        <th>
                                                                            Add
                                                                            On
                                                                            Price
                                                                        </th>
                                                                    </tr>
                                                                </thead>

                                                                <tbody>
                                                                    <tr
                                                                        v-for="(
                                                                            moredecoration,
                                                                            index
                                                                        ) in more_decoration_list"
                                                                        :key="
                                                                            index
                                                                        "
                                                                    >
                                                                        <td>
                                                                            {{
                                                                                moredecoration.name
                                                                            }}
                                                                        </td>
                                                                        <td>
                                                                            {{
                                                                                moredecoration.description
                                                                            }}
                                                                        </td>
                                                                        <td>
                                                                            {{
                                                                                moredecoration.decoration_type
                                                                            }}
                                                                        </td>
                                                                        <td
                                                                            class="edit-table-column"
                                                                            @mouseover="
                                                                                isHovering = true
                                                                            "
                                                                            @mouseout="
                                                                                isHovering = false
                                                                            "
                                                                        >
                                                                            <template
                                                                                v-if="
                                                                                    moredecoration.price_type ==
                                                                                    'Price'
                                                                                "
                                                                            >
                                                                                {{
                                                                                    icPriceFormat(
                                                                                        moredecoration.price
                                                                                    )
                                                                                }}
                                                                            </template>
                                                                            <template
                                                                                v-else
                                                                            >
                                                                                <span
                                                                                    v-html="
                                                                                        tireName(
                                                                                            moredecoration.tier_id
                                                                                        )
                                                                                    "
                                                                                >
                                                                                </span>
                                                                            </template>
                                                                        </td>
                                                                        <td>
                                                                            {{
                                                                                icPriceFormat(
                                                                                    moredecoration.add_on_price
                                                                                )
                                                                            }}
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div> -->

                                                <div
                                                    class="tab-pane fade"
                                                    v-if="
                                                        otherServices.length > 0
                                                    "
                                                    id="decoration"
                                                    role="tabpanel"
                                                    aria-labelledby="profile-tab1"
                                                >
                                                    <div class="tabs_table">
                                                        <div
                                                            class="available_color_columns no_borders_custom decoration_table_product_detais_custom"
                                                        >
                                                            <table
                                                                class="table table-bordered"
                                                            >
                                                                <thead>
                                                                    <tr>
                                                                        <th>
                                                                            Name
                                                                        </th>
                                                                        <th
                                                                            width="700"
                                                                        >
                                                                            Description
                                                                        </th>
                                                                        <th>
                                                                            Fee
                                                                            Structure
                                                                        </th>
                                                                        <th>
                                                                            Price
                                                                        </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr
                                                                        v-for="(
                                                                            service,
                                                                            index
                                                                        ) in otherServices"
                                                                        :key="
                                                                            index
                                                                        "
                                                                    >
                                                                        <td>
                                                                            {{
                                                                                service.name
                                                                            }}
                                                                        </td>
                                                                        <td>
                                                                            {{
                                                                                service.description
                                                                            }}
                                                                        </td>
                                                                        <td>
                                                                            {{
                                                                                service.fee_structure
                                                                            }}
                                                                        </td>
                                                                        <td>
                                                                            {{
                                                                                icPriceFormat(
                                                                                    service.retail_cost
                                                                                )
                                                                            }}
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    class="tab-pane fade"
                                                    v-if="
                                                        product.Brand &&
                                                        product.Brand
                                                            .size_chart_image
                                                    "
                                                    id="size_chart"
                                                    role="tabpanel"
                                                    aria-labelledby="contact-tab1"
                                                >
                                                    <div
                                                        class="product_details product_details_vue"
                                                    >
                                                        <div
                                                            class="products_count_tab mt_30 product_details_content"
                                                        >
                                                            <div
                                                                class="products_count_tab"
                                                            >
                                                                <embed
                                                                    v-if="
                                                                        getUrlExtension(
                                                                            product
                                                                                .Brand
                                                                                .size_chart_image
                                                                        ) ==
                                                                        'pdf'
                                                                    "
                                                                    :src="`${product.Brand.size_chart_image}#toolbar=0&navpanes=0&scrollbar=0`"
                                                                    width="100%"
                                                                    height="800px"
                                                                />
                                                                <img
                                                                    v-else
                                                                    :src="
                                                                        product
                                                                            .Brand
                                                                            .size_chart_image
                                                                    "
                                                                    alt=""
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            class="col-md-12 col-lg-6 pl_84 pr_34 product_details_content"
                        >
                            <div class="product_headding d-flex">
                                <h1 class="heading1 w-75">
                                    {{ product.name | capitalize }}
                                </h1>
                                <div
                                    v-if="product.Brand"
                                    class="company_logo ml-auto w-25 text-right"
                                >
                                    <router-link
                                        v-tooltip="product.Brand.name"
                                        :to="{
                                            path:
                                                '/brand/' +
                                                (product.Brand.slug
                                                    ? product.Brand.slug
                                                    : product.Brand.id)
                                        }"
                                    >
                                        <img
                                            :src="
                                                product.Brand.logo_file
                                                    ? product.Brand.logo_file
                                                    : '/maincss/images/brand_logo.png'
                                            "
                                            alt=" "
                                        />
                                    </router-link>
                                </div>
                            </div>
                            <div class="d-flex align-items-center mt_6">
                                <h4
                                    class="font_size_28 text_primary_blue m-0 text-uppercase"
                                >
                                    {{ product.product_number }}
                                </h4>
                            </div>

                            <div class="product_details_content">
                                <div class="product_details_radio_btn">
                                    <form action="#">
                                        <div
                                            class="form__group d-flex align-items-center mt_28"
                                        >
                                            <div
                                                v-show="
                                                    decoration_services_show
                                                "
                                                v-for="(
                                                    dec_service, dec_key
                                                ) in decoration_services"
                                                :class="
                                                    (dec_service.isActive
                                                        ? 'active '
                                                        : '') +
                                                    'form__radio-group'
                                                "
                                                :key="dec_service.id"
                                            >
                                                <input
                                                    type="radio"
                                                    name="decoration_services"
                                                    :id="dec_service.id"
                                                    :value="dec_service.name"
                                                    :checked="
                                                        dec_service.isActive
                                                    "
                                                    v-on:input="
                                                        changeDecorationService(
                                                            dec_key
                                                        )
                                                    "
                                                    class="form__radio-input"
                                                />
                                                <label
                                                    :for="dec_service.id"
                                                    class="form__label-radio"
                                                >
                                                    <img
                                                        src="/maincss/images/checked_shipping_white.svg"
                                                        alt=""
                                                    />
                                                    {{ dec_service.name }}
                                                </label>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div
                                    class="product_count_pricing mt_24"
                                    v-if="priceTableData.length > 0"
                                >
                                    <div
                                        class="product_count_pricing mt_24"
                                        v-if="priceTableData.length > 0"
                                    >
                                        <div
                                            class="table-responsive product_x-scroll"
                                        >
                                            <table
                                                class="table text-center pricing-table"
                                            >
                                                <thead>
                                                    <tr>
                                                        <th
                                                            style="
                                                                width: 100px;
                                                                text-align: left;
                                                            "
                                                        >
                                                            Quantity
                                                        </th>
                                                        <th
                                                            v-for="(
                                                                item, index
                                                            ) in priceTableData"
                                                            :key="`qty-${index}`"
                                                        >
                                                            {{ item.quantity }}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td class="text-left">
                                                            <strong
                                                                >Retail</strong
                                                            >
                                                        </td>
                                                        <td
                                                            v-for="(
                                                                item, index
                                                            ) in priceTableData"
                                                            :key="`retail-${index}`"
                                                        >
                                                            {{
                                                                icPriceFormat(
                                                                    item.retail_cost
                                                                )
                                                            }}
                                                        </td>
                                                    </tr>
                                                    <tr
                                                        v-if="
                                                            isPreviewMode &&
                                                            !isAdminLoggedIn
                                                        "
                                                    >
                                                        <td class="text-left">
                                                            <strong
                                                                >Cost</strong
                                                            >
                                                        </td>
                                                        <td
                                                            v-for="(
                                                                item, index
                                                            ) in priceTableData"
                                                            :key="`cost-${index}`"
                                                        >
                                                            {{
                                                                icPriceFormat(
                                                                    item.net_cost
                                                                )
                                                            }}
                                                        </td>
                                                    </tr>
                                                    <tr
                                                        v-if="
                                                            isPreviewMode &&
                                                            !isAdminLoggedIn
                                                        "
                                                    >
                                                        <td class="text-left">
                                                            <strong
                                                                >Margin</strong
                                                            >
                                                        </td>
                                                        <td
                                                            v-for="(
                                                                item, index
                                                            ) in priceTableData"
                                                            :key="`margin-${index}`"
                                                        >
                                                            {{
                                                                icPriceFormat(
                                                                    item.retail_cost -
                                                                        item.net_cost
                                                                )
                                                            }}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <p
                                class="base_price mt-1"
                                v-if="product.decoration_type == 1"
                            >
                                *Base price includes 1-color imprint in
                                1-location up to size XL. Larger sizes may incur
                                additional costs. Customize further to see
                                additional pricing.
                            </p>
                            <p
                                class="base_price mt-1"
                                v-if="product.decoration_type == 2"
                            >
                                *Pricing includes embroidery up to 10,000
                                stitches in 1-location up to size XL. Larger
                                sizes may incur additional costs. +$0.50 per
                                additional 1,000 stitches over 10,000.
                            </p>
                            <div class="mt-1">
                                <strong>
                                    Minimum Order Quantity :
                                    <span>{{ minimumOrderQuantity }}</span>
                                </strong>
                            </div>
                            <div class="products_count_tab mt_30">
                                <ul
                                    class="nav nav-tabs overfolw_x_scroll"
                                    id="myTab"
                                    role="tablist"
                                >
                                    <li
                                        @click="activeLink(index)"
                                        class="nav-item"
                                        :class="{ active: is_active == index }"
                                        v-for="(gender, index) in gender_groups"
                                        :key="index"
                                        role="presentation"
                                    >
                                        <a
                                            class="nav-link"
                                            :id="index + '-tab'"
                                            role="tab"
                                            aria-controls="profile"
                                            aria-selected="false"
                                            >{{ gender.gender }}</a
                                        >
                                    </li>
                                </ul>
                                <div
                                    class="row"
                                    v-for="(gender, index) in gender_groups"
                                    :key="index"
                                    v-show="index == is_active"
                                >
                                    <div
                                        class="col-md-10 col-lg-9 color_checkboxes_mr"
                                    >
                                        <h4
                                            class="available_colors font_size_17 mt_20 mb_0"
                                        >
                                            Available Colors
                                        </h4>
                                        <div
                                            class="d-flex flex-wrap justify-content-left color_checkbox"
                                        >
                                            <div
                                                v-for="(
                                                    gendercolors, ind
                                                ) in colors"
                                                :key="ind"
                                                class="form-check pl-0 mt_10"
                                            >
                                                <label
                                                    v-show="ind <= 9"
                                                    class="checkbox_custom"
                                                    v-tooltip="
                                                        gendercolors.color_name
                                                    "
                                                    :class="{
                                                        'checkmark-black':
                                                            gendercolors.is_selected &&
                                                            gendercolors.hash ==
                                                                '#ffffff',
                                                        'check-active':
                                                            gendercolors.is_selected &&
                                                            gendercolors.hash !=
                                                                '#ffffff'
                                                    }"
                                                >
                                                    <input
                                                        type="checkbox"
                                                        :id="`gender_${gender.id}_color_${gendercolors.id}`"
                                                        :name="
                                                            'avilable_color_' +
                                                            index
                                                        "
                                                        @change="
                                                            getsizeByColor(
                                                                gendercolors,
                                                                $event
                                                            )
                                                        "
                                                        v-model="
                                                            gendercolors.is_selected
                                                        "
                                                    />
                                                    <img
                                                        v-if="
                                                            gendercolors.swatches
                                                        "
                                                        :src="
                                                            gendercolors.swatches
                                                        "
                                                        class="checkmark"
                                                        :class="[
                                                            gendercolors.hash ==
                                                            '#FFFFFF'
                                                                ? 'bg-white'
                                                                : ''
                                                        ]"
                                                    />
                                                    <span
                                                        v-else
                                                        :class="
                                                            gendercolors.hash.trim() ==
                                                            '#ffffff'
                                                                ? 'checkmark checkmark_black'
                                                                : 'checkmark'
                                                        "
                                                        v-bind:style="
                                                            'background:' +
                                                            gendercolors.hash
                                                        "
                                                    ></span>
                                                </label>

                                                <div v-if="is_color_show_more">
                                                    <label
                                                        v-show="ind > 9"
                                                        class="checkbox_custom"
                                                        v-tooltip="
                                                            gendercolors.color_name
                                                        "
                                                        :class="{
                                                            'checkmark-black':
                                                                gendercolors.is_selected &&
                                                                gendercolors.hash ==
                                                                    '#ffffff',
                                                            'check-active':
                                                                gendercolors.is_selected &&
                                                                gendercolors.hash !=
                                                                    '#ffffff'
                                                        }"
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            :id="`gender_${gender.id}_color_${gendercolors.id}`"
                                                            :name="
                                                                'avilable_color_' +
                                                                index
                                                            "
                                                            @change="
                                                                getsizeByColor(
                                                                    gendercolors,
                                                                    $event
                                                                )
                                                            "
                                                            v-model="
                                                                gendercolors.is_selected
                                                            "
                                                        />
                                                        <img
                                                            v-if="
                                                                gendercolors.swatches
                                                            "
                                                            :src="
                                                                gendercolors.swatches
                                                            "
                                                            class="checkmark"
                                                            :class="[
                                                                gendercolors.hash ==
                                                                '#FFFFFF'
                                                                    ? 'bg-white'
                                                                    : ''
                                                            ]"
                                                        />
                                                        <span
                                                            v-else
                                                            :class="
                                                                gendercolors.hash.trim() ==
                                                                '#ffffff'
                                                                    ? 'checkmark checkmark_black'
                                                                    : 'checkmark'
                                                            "
                                                            v-bind:style="
                                                                'background:' +
                                                                gendercolors.hash
                                                            "
                                                        ></span>
                                                    </label>
                                                </div>
                                            </div>

                                            <div
                                                v-show="colors.length > 10"
                                                class="form-check pl-0 mt_10"
                                            >
                                                <label class="checkbox_custom">
                                                    <input
                                                        type="checkbox"
                                                        @click="
                                                            showMore(
                                                                'is_color_show_more'
                                                            )
                                                        "
                                                    />
                                                    <span
                                                        class="checkmark check_box plus_icon-align"
                                                        v-bind:class="
                                                            is_color_show_more
                                                                ? 'minus_box'
                                                                : ''
                                                        "
                                                    >
                                                        <img
                                                            v-if="
                                                                is_color_show_more
                                                            "
                                                            src="/maincss/images/minus1.svg"
                                                        />
                                                        <template v-else
                                                            >+{{
                                                                colors.length -
                                                                10
                                                            }}</template
                                                        >
                                                    </span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="tab-content mt_12"
                                    id="myTabContent"
                                >
                                    <div
                                        class="tab-pane fade show active"
                                        v-for="(gender, index) in gender_groups"
                                        :key="index"
                                        :id="index"
                                        role="tabpanel"
                                        :aria-labelledb="index + '-tab'"
                                        v-show="is_active == index"
                                    >
                                        <div class="tab_pro_panel">
                                            <div
                                                v-for="picked_color in gender.selected_colors"
                                                :key="picked_color.id"
                                                class="tabs_table d-md-flex size_color_table"
                                            >
                                                <div
                                                    class="available_color_columns"
                                                >
                                                    <div
                                                        class="color d-flex align-items-center color_column"
                                                    >
                                                        <img
                                                            v-if="
                                                                picked_color.swatches
                                                            "
                                                            class="color_box mr_10"
                                                            :src="
                                                                picked_color.swatches
                                                            "
                                                        />
                                                        <div
                                                            v-else
                                                            class="color_box mr_10"
                                                            :style="
                                                                'background: ' +
                                                                picked_color.hash
                                                            "
                                                        ></div>
                                                        <h5 class="color-name">
                                                            {{
                                                                converToCamel(
                                                                    picked_color.color_name
                                                                )
                                                            }}
                                                            - Sizes
                                                        </h5>
                                                    </div>
                                                </div>
                                                <div class="sizez_columns">
                                                    <div
                                                        class="d-flex flex-wrap inner_size_table"
                                                    >
                                                        <div
                                                            class="product_count"
                                                            v-for="(
                                                                gendersizes,
                                                                indx
                                                            ) in picked_color[
                                                                'unique_sizes'
                                                            ]"
                                                            :key="indx"
                                                        >
                                                            <div
                                                                class="count_item_heading"
                                                            >
                                                                <h6 class="m-0">
                                                                    {{
                                                                        gendersizes
                                                                            .Size
                                                                            .size
                                                                    }}
                                                                </h6>
                                                                <span>
                                                                    {{
                                                                        icPriceFormat(
                                                                            gendersizes.cost
                                                                        )
                                                                    }}
                                                                </span>
                                                            </div>
                                                            <div
                                                                class="count_item_price"
                                                            >
                                                                <input
                                                                    type="text"
                                                                    oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');"
                                                                    v-model="
                                                                        gendersizes.quantity
                                                                    "
                                                                    @change="
                                                                        calculatePricing(
                                                                            index,
                                                                            gendersizes,
                                                                            $event
                                                                        )
                                                                    "
                                                                    class="form-control"
                                                                    placeholder="0"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="product_count total_count d-none"
                                                        >
                                                            <div
                                                                class="count_item_heading"
                                                            >
                                                                <h6 class="m-0">
                                                                    Total
                                                                </h6>
                                                            </div>
                                                            <div
                                                                class="count_item_price total_box"
                                                            >
                                                                <b>{{
                                                                    icPriceFormat(
                                                                        picked_color.total_cost_gender_wise
                                                                    )
                                                                }}</b>
                                                                <!-- <input readonly type="text" :value="icPriceFormat(picked_color.total_cost_gender_wise)"
                                  class="form-control" placeholder="0" /> -->
                                                                <div
                                                                    class="dropdown"
                                                                    v-if="
                                                                        picked_color.total_qty_gender_wise >
                                                                        0
                                                                    "
                                                                >
                                                                    <a
                                                                        href="javascript:void(0);"
                                                                        class="dropdown-toggle d-flex align-items-center"
                                                                        :id="
                                                                            'dropdownMenuButton' +
                                                                            picked_color.id
                                                                        "
                                                                        data-toggle="dropdown"
                                                                        aria-haspopup="true"
                                                                        aria-expanded="false"
                                                                    >
                                                                        <img
                                                                            src="/maincss/images/path.png"
                                                                            class="ml_6 path"
                                                                        />
                                                                    </a>

                                                                    <div
                                                                        class="dropdown-menu drop-cart-menu drop_product"
                                                                        aria-labelledby="dropdownMenuButton"
                                                                    >
                                                                        <h4
                                                                            class="font_size_16 text_primary_blue py_2 px_20"
                                                                        >
                                                                            {{
                                                                                converToCamel(
                                                                                    picked_color.color_name
                                                                                )
                                                                            }}
                                                                            <span
                                                                                class="cross_ic"
                                                                            >
                                                                                <img
                                                                                    src="/maincss/images/cross.svg"
                                                                                />
                                                                            </span>
                                                                        </h4>
                                                                        <div
                                                                            class="scroll"
                                                                        >
                                                                            <div>
                                                                                <div
                                                                                    class="col-md-12"
                                                                                >
                                                                                    <div
                                                                                        class="mt_10 d-flex flex-wrap justify-content-left color_checkbox"
                                                                                    >
                                                                                        <div
                                                                                            class="table-responsive"
                                                                                        >
                                                                                            <table
                                                                                                width="100%"
                                                                                                class="table-bordered comma-decimal-place table-data table-hover space_b"
                                                                                            >
                                                                                                <thead>
                                                                                                    <tr>
                                                                                                        <th>
                                                                                                            Size
                                                                                                        </th>
                                                                                                        <th>
                                                                                                            Quantity
                                                                                                        </th>
                                                                                                        <th>
                                                                                                            Total
                                                                                                        </th>
                                                                                                    </tr>
                                                                                                </thead>
                                                                                                <tbody>
                                                                                                    <tr
                                                                                                        v-for="(
                                                                                                            size,
                                                                                                            ind
                                                                                                        ) in picked_color[
                                                                                                            'unique_sizes'
                                                                                                        ]"
                                                                                                        :key="
                                                                                                            ind
                                                                                                        "
                                                                                                        v-show="
                                                                                                            size.quantity >
                                                                                                            0
                                                                                                        "
                                                                                                    >
                                                                                                        <td
                                                                                                            class="size"
                                                                                                        >
                                                                                                            {{
                                                                                                                size
                                                                                                                    .Size
                                                                                                                    .size
                                                                                                            }}
                                                                                                        </td>
                                                                                                        <td>
                                                                                                            {{
                                                                                                                size.quantity
                                                                                                            }}
                                                                                                            *
                                                                                                            {{
                                                                                                                icPriceFormat(
                                                                                                                    size.cost
                                                                                                                )
                                                                                                            }}
                                                                                                        </td>
                                                                                                        <td>
                                                                                                            {{
                                                                                                                icPriceFormat(
                                                                                                                    size.total_cost
                                                                                                                )
                                                                                                            }}
                                                                                                        </td>
                                                                                                    </tr>
                                                                                                </tbody>
                                                                                            </table>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div
                                                                                    class="col-md-12"
                                                                                >
                                                                                    <div
                                                                                        class="mt_10 d-flex flex-wrap justify-content-left color_checkbox"
                                                                                        v-if="
                                                                                            parseFloat(
                                                                                                picked_color.total_design_fee
                                                                                            ) >
                                                                                            0
                                                                                        "
                                                                                    >
                                                                                        <p
                                                                                            class="font-weight-bold w-90 m-0"
                                                                                        >
                                                                                            Design
                                                                                            Fee:
                                                                                        </p>
                                                                                        <p
                                                                                            class="ml-auto mb-0"
                                                                                        >
                                                                                            {{
                                                                                                picked_color.total_design_fee >=
                                                                                                0
                                                                                                    ? icPriceFormat(
                                                                                                          picked_color.total_design_fee
                                                                                                      )
                                                                                                    : 0.0
                                                                                            }}
                                                                                        </p>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <span
                                                        class="d-block multiple_error"
                                                        v-if="
                                                            picked_color.existing_cart_quantity
                                                        "
                                                    >
                                                        This color already added
                                                        in cart with
                                                        {{
                                                            picked_color.existing_cart_quantity
                                                        }}.
                                                    </span>
                                                </div>
                                                <a
                                                    href="javascript:void(0);"
                                                    class="mt-1"
                                                >
                                                    <img
                                                        @click="
                                                            getsizeByColor(
                                                                picked_color
                                                            )
                                                        "
                                                        src="/maincss/images/icons/delete_dark.svg"
                                                    />
                                                </a>
                                            </div>
                                        </div>

                                        <!-- START IMPRINT LOCATION COLORS -->
                                        <div
                                            class="right_section_main"
                                            v-if="choose_imprint_locations"
                                        >
                                            <h5
                                                class="mt-4"
                                                v-if="
                                                    product.decoration_type == 1
                                                "
                                            >
                                                Select imprint locations and
                                                number of ink colors
                                            </h5>
                                            <h5
                                                class="mt-4"
                                                v-else-if="
                                                    product.decoration_type == 2
                                                "
                                            >
                                                Select embroidery locations and
                                                number of thread colors
                                            </h5>
                                            <div class="right_section">
                                                <div class="alignment_section">
                                                    <div
                                                        class="right_items w-100"
                                                        :class="{
                                                            checkbox_checked:
                                                                implicitylocation.is_selected
                                                        }"
                                                        v-for="(
                                                            implicitylocation,
                                                            l_inx
                                                        ) in imprint_locations"
                                                        :key="l_inx"
                                                    >
                                                        <div
                                                            class="images_right"
                                                            @click="
                                                                selectImprintLocations(
                                                                    l_inx
                                                                )
                                                            "
                                                        >
                                                            <img
                                                                class="direct"
                                                                :src="
                                                                    implicitylocation.image_path
                                                                "
                                                                alt=""
                                                            />
                                                            <input
                                                                type="checkbox"
                                                                :name="
                                                                    'is_selected_location' +
                                                                    l_inx
                                                                "
                                                                :class="{
                                                                    checked:
                                                                        implicitylocation.is_selected
                                                                }"
                                                                :id="
                                                                    'same-address' +
                                                                    l_inx
                                                                "
                                                                :checked="
                                                                    implicitylocation.is_selected
                                                                "
                                                            />
                                                        </div>
                                                        <p>
                                                            {{
                                                                implicitylocation.location
                                                            }}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div
                                                    class="select-imprint-area mt_24 popup_right_section"
                                                    v-show="is_imprint_location"
                                                >
                                                    <div
                                                        class="imprint-area-box imprint-product_area_box mb_40 popup_dropdown"
                                                    >
                                                        <div id="accordion">
                                                            <div class="">
                                                                <div
                                                                    class=""
                                                                    id="select-one"
                                                                >
                                                                    <h5
                                                                        class="mb-0"
                                                                        v-for="(
                                                                            implicitylocation,
                                                                            l_inx
                                                                        ) in imprint_locations"
                                                                        :key="
                                                                            l_inx
                                                                        "
                                                                    >
                                                                        <div
                                                                            class="left-chest-"
                                                                            v-if="
                                                                                implicitylocation.is_selected
                                                                            "
                                                                        >
                                                                            <div
                                                                                class="row left_botom_0"
                                                                            >
                                                                                <div
                                                                                    class="col-md-6 align-self-end drop-sec"
                                                                                >
                                                                                    <label
                                                                                        class="label-head"
                                                                                        style="
                                                                                            cursor: pointer;
                                                                                        "
                                                                                        for="left-chest"
                                                                                    >
                                                                                        {{
                                                                                            implicitylocation.location
                                                                                        }}
                                                                                        <p
                                                                                            v-if="
                                                                                                decoration_type ==
                                                                                                1
                                                                                            "
                                                                                        >
                                                                                            (choose
                                                                                            ink
                                                                                            colors)
                                                                                        </p>
                                                                                        <p
                                                                                            v-if="
                                                                                                decoration_type ==
                                                                                                2
                                                                                            "
                                                                                        >
                                                                                            (choose
                                                                                            thread
                                                                                            colors)
                                                                                        </p>
                                                                                        <p
                                                                                            v-if="
                                                                                                decoration_type ==
                                                                                                3
                                                                                            "
                                                                                        >
                                                                                            (choose
                                                                                            vinyl
                                                                                            colors)
                                                                                        </p>
                                                                                    </label>
                                                                                </div>
                                                                                <div
                                                                                    class="col-md-4 dropdown_colors"
                                                                                >
                                                                                    <div
                                                                                        class="form-group mt-0"
                                                                                    >
                                                                                        <v-select
                                                                                            width="100%"
                                                                                            placeholder="Select-colors"
                                                                                            label="value"
                                                                                            :reduce="
                                                                                                (
                                                                                                    color
                                                                                                ) =>
                                                                                                    color.id
                                                                                            "
                                                                                            :options="
                                                                                                imprintcityColors
                                                                                            "
                                                                                            v-model="
                                                                                                implicitylocation.no_of_color
                                                                                            "
                                                                                            @input="
                                                                                                selectNumberOfColors(
                                                                                                    implicitylocation,
                                                                                                    $event
                                                                                                )
                                                                                            "
                                                                                        ></v-select>
                                                                                    </div>
                                                                                </div>
                                                                                <div
                                                                                    class="col-md-2 cost_right"
                                                                                >
                                                                                    <span
                                                                                        class="mt-1 d-none"
                                                                                        v-if="
                                                                                            implicitylocation.decoration_fee
                                                                                        "
                                                                                    >
                                                                                        +
                                                                                        {{
                                                                                            icPriceFormat(
                                                                                                implicitylocation.decoration_fee
                                                                                            )
                                                                                        }}
                                                                                    </span>
                                                                                </div>
                                                                            </div>

                                                                            <!-- <div :id="`collapseColors${l_inx}`"
                                                                                class="collapse show"
                                                                                aria-labelledby="select-one"
                                                                                data-parent="#accordion">
                                                                                <div class="card-body">
                                                                                    <div class="row select_color"
                                                                                        v-show="implicitylocation.no_of_color > 0"
                                                                                        v-for="(colors, c_inx) in implicitylocation.colors"
                                                                                        :key="c_inx">
                                                                                        <div
                                                                                            class="col-md-6 align-self-end drop_menus">
                                                                                            <label>
                                                                                                <span
                                                                                                    v-if="decoration_type == 1">
                                                                                                    Select
                                                                                                    Imprint
                                                                                                    Color -
                                                                                                    {{ c_inx
                                                                                                        + 1
                                                                                                    }}</span>
                                                                                                <span
                                                                                                    v-else-if="decoration_type == 2">
                                                                                                    Select
                                                                                                    Thread
                                                                                                    Color -
                                                                                                    {{ c_inx
                                                                                                        + 1
                                                                                                    }}</span>
                                                                                                <span
                                                                                                    v-else-if="decoration_type == 3">
                                                                                                    Select
                                                                                                    Vinyl
                                                                                                    Color -
                                                                                                    {{ c_inx
                                                                                                        + 1
                                                                                                    }}</span>
                                                                                            </label>
                                                                                        </div>
                                                                                        <div class="col-md-6">
                                                                                            <div class="form-group mt_0">
                                                                                                <v-select
                                                                                                    :filter="fuseSearch"
                                                                                                    :options="filterVendorColors(imprint_colors_array_for_template, l_inx)"
                                                                                                    :get-option-label="(option) => option.color_name"
                                                                                                    placeholder="Select"
                                                                                                    v-model="colors.color"
                                                                                                    @input="getColorWiseCost(c_inx, l_inx, is_active, $event)">
                                                                                                    <template
                                                                                                        #option="{ color_value, color_name, swatch_file }">
                                                                                                        <span
                                                                                                            v-if="color_value">
                                                                                                            <cite
                                                                                                                class="imprint_color_box"
                                                                                                                v-bind:style="'background:' + color_value"></cite>
                                                                                                            {{
                                                                                                                color_name
                                                                                                            }}
                                                                                                        </span>
                                                                                                        <span v-else>
                                                                                                            <img class="imprint_color_box"
                                                                                                                :src="swatch_file"
                                                                                                                alt="" />
                                                                                                            {{
                                                                                                                color_name
                                                                                                            }}
                                                                                                        </span>
                                                                                                    </template>
                                                                                                </v-select>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div> -->
                                                                        </div>
                                                                    </h5>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- END IMPRINT LOCATION COLORS -->

                                        <!-- <div class="d-md-flex mt_26 cost_total_col" v-if="hashcolor[index]"> -->
                                        <div
                                            v-if="
                                                activeDecorationService &&
                                                gender.total_qty_gender_wise > 0
                                            "
                                        >
                                            <PCNAPriceBreakdown
                                                v-if="
                                                    activeDecorationService.use_imprintcity_price_template ===
                                                        0 &&
                                                    activeDecorationService.master_service
                                                "
                                                :key="
                                                    activeDecorationService.id +
                                                    '_' +
                                                    gender.total_qty_gender_wise
                                                "
                                                :quantity="
                                                    gender.total_qty_gender_wise
                                                "
                                                :other-services="otherServices"
                                                :base-cost="
                                                    currentBreakdown.baseCost
                                                "
                                                :run-charge="
                                                    currentBreakdown.runCharge
                                                "
                                                :run-charge-details="
                                                    currentBreakdown.runChargeDetails ||
                                                    []
                                                "
                                                :setup-fee="
                                                    currentBreakdown.setupFee
                                                "
                                                :subtotal="
                                                    currentBreakdown.totalCost
                                                "
                                                :total-discount="
                                                    currentBreakdown.totalDiscount
                                                "
                                                :discount-config="
                                                    activeProductDiscount
                                                "
                                                :imprint-locations="
                                                    imprint_locations
                                                "
                                                :service-master-data="
                                                    activeDecorationService.master_service ||
                                                    {}
                                                "
                                                :stitch-count="0"
                                                :color-size-combinations="
                                                    getColorSizeCombinations(
                                                        gender
                                                    )
                                                "
                                            />

                                            <ImprintCityPriceBreakdown
                                                v-else
                                                :quantity="
                                                    gender.total_qty_gender_wise
                                                "
                                                :design-fee="
                                                    gender.total_design_fee
                                                "
                                                :total-discount="
                                                    gender.total_discount_value
                                                "
                                                :discount-config="
                                                    activeProductDiscount
                                                "
                                                :other-services="otherServices"
                                                :base-cost="
                                                    currentBreakdown.baseCost
                                                "
                                                :run-charge="
                                                    currentBreakdown.runCharge
                                                "
                                                :setup-fee="
                                                    currentBreakdown.setupFee
                                                "
                                                :total-cost="
                                                    currentBreakdown.totalCost
                                                "
                                                :run-charge-details="
                                                    currentBreakdown.runChargeDetails ||
                                                    []
                                                "
                                                :imprint-locations="
                                                    imprint_locations
                                                "
                                                :service-master-data="
                                                    activeDecorationService.master_service ||
                                                    {}
                                                "
                                                :active-decoration-service="
                                                    activeDecorationService ||
                                                    null
                                                "
                                                :decoration-pricing-data="
                                                    activeDecorationService.price_decoration_bulk ||
                                                    null
                                                "
                                                :decoration-type="
                                                    activeDecorationService.decoration_type ||
                                                    1
                                                "
                                                :total-quantity="
                                                    gender.total_qty_gender_wise
                                                "
                                                :color-size-combinations="
                                                    getColorSizeCombinations(
                                                        gender
                                                    )
                                                "
                                            />
                                        </div>
                                    </div>
                                </div>

                                <p
                                    class="base_price d-none"
                                    v-if="product.decoration_type == 1"
                                >
                                    *Base price includes 1-color imprint in
                                    1-location up to size XL. Larger sizes may
                                    incur additional costs. Customize further to
                                    see additional pricing.
                                </p>
                                <p
                                    class="base_price d-none"
                                    v-if="product.decoration_type == 2"
                                >
                                    *Pricing includes embroidery up to 10,000
                                    stitches in 1-location up to size XL. Larger
                                    sizes may incur additional costs. +$0.50 per
                                    additional 1,000 stitches over 10,000.
                                </p>

                                <div
                                    class="action-contents"
                                    v-if="!isPreviewMode"
                                >
                                    <a href="javascript:void(0);">
                                        <img
                                            src="/maincss/images/path.png"
                                            alt=""
                                    /></a>
                                    <p class="m-0">
                                        Want to add another shirt style with the
                                        same artwork? Click “Start Designing“
                                        button. If not, click the Add Artwork
                                        Work button to add or create your
                                        artwork.
                                    </p>
                                </div>
                                <div class="buttons mt_0 add_new_button">
                                    <a
                                        v-if="!isPreviewMode"
                                        href="Javascript:void(0);"
                                        class="btn btn_orange btn btn_orange bg_primary_orange text_white login-cart"
                                        :class="{ disabled: disable_btns }"
                                        @click="openStartDesignModal"
                                    >
                                        Start Designing/Add Artwork
                                    </a>

                                    <div
                                        class="modal login-form-popup like_design_popup fade h-auto"
                                        id="add-art-work"
                                        tabindex="-1"
                                        aria-labelledby="art-work"
                                        aria-hidden="true"
                                        data-keyboard="false"
                                        data-backdrop="static"
                                    >
                                        <div
                                            class="modal-dialog modal-dialog-centered"
                                        >
                                            <div class="modal-content">
                                                <div class="modal-header">
                                                    <div class="header_items">
                                                        <div>
                                                            <h5
                                                                class="modal-title"
                                                            >
                                                                How would you
                                                                like to design
                                                                your item ?
                                                            </h5>
                                                        </div>

                                                        <div
                                                            class="close_modal"
                                                        >
                                                            <a
                                                                href="#"
                                                                class="popup-close art_poup_close"
                                                                id="popup-close"
                                                                data-dismiss="modal"
                                                                ref="popupclose"
                                                            >
                                                                <span
                                                                    aria-hidden="true"
                                                                    v-tooltip="
                                                                        'Close'
                                                                    "
                                                                    >&times;</span
                                                                >
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="modal-body">
                                                    <div
                                                        class="form-check"
                                                        @click="
                                                            start_designing_with =
                                                                'scratch'
                                                        "
                                                    >
                                                        <input
                                                            class="form-check-input"
                                                            type="radio"
                                                            name="flexRadioDefault"
                                                            id="flexRadioDefault1"
                                                            @click="
                                                                start_designing_with =
                                                                    'scratch'
                                                            "
                                                            checked
                                                        />
                                                        <label
                                                            class="form-check-label"
                                                            @click="
                                                                start_designing_with =
                                                                    'scratch'
                                                            "
                                                            for="flexRadioDefault1"
                                                        >
                                                            Start from scratch
                                                            with Imprint City
                                                            Text and Graphics
                                                        </label>
                                                    </div>
                                                    <div class="form-check">
                                                        <input
                                                            class="form-check-input"
                                                            type="radio"
                                                            name="flexRadioDefault"
                                                            id="flexRadioDefault2"
                                                            @click="
                                                                start_designing_with =
                                                                    'existing'
                                                            "
                                                        />
                                                        <label
                                                            class="form-check-label"
                                                            for="flexRadioDefault2"
                                                            @click="
                                                                start_designing_with =
                                                                    'existing'
                                                            "
                                                        >
                                                            Use One of My
                                                            Existing Design
                                                        </label>
                                                    </div>
                                                    <div class="form-check">
                                                        <input
                                                            class="form-check-input"
                                                            type="radio"
                                                            name="flexRadioDefault"
                                                            id="flexRadioDefault3"
                                                            @click="
                                                                start_designing_with =
                                                                    'upload'
                                                            "
                                                        />
                                                        <label
                                                            class="form-check-label"
                                                            for="flexRadioDefault3"
                                                            @click="
                                                                start_designing_with =
                                                                    'upload'
                                                            "
                                                        >
                                                            Upload some new
                                                            graphics
                                                        </label>
                                                    </div>
                                                </div>
                                                <div class="modal-footer">
                                                    <button
                                                        type="button"
                                                        @click="startDesign()"
                                                    >
                                                        Next
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!--crop popup-->
                <div
                    class="modal login-form-popup fade h-auto"
                    id="crop_modal"
                    tabindex="-1"
                    aria-labelledby="login"
                    aria-hidden="true"
                    data-keyboard="false"
                    data-backdrop="static"
                >
                    <div
                        class="modal-dialog modal-dialog-centered modal-dialog-scrollable large_popup_l upload_art_popup"
                    >
                        <div class="modal-content">
                            <div class="modal-header">
                                <h3>Upload</h3>
                                <a
                                    href="#"
                                    class="popup-close"
                                    id="popup-close"
                                    data-dismiss="modal"
                                    @click="cancelUploadArtwork"
                                >
                                    <img
                                        src="/maincss/images/cancel.svg"
                                        alt=" "
                                    />
                                </a>
                            </div>
                            <div class="modal-body">
                                <div class="login-form">
                                    <div class="upload_crop_design_studio row">
                                        <div class="left_panel col-md-6">
                                            <input
                                                class="crop_bdr"
                                                id="crop_bdr"
                                                type="file"
                                                @change="croppie"
                                                v-tooltip="
                                                    'Accepting png, jpg, and jpeg format'
                                                "
                                            />
                                            <span class="uplod-size"
                                                >Accepting only Png, Jpg, Jpeg,
                                                Svg, Pdf, Ai, Eps files</span
                                            >
                                            <small
                                                class="form-text text-error"
                                                v-if="
                                                    crop_image_validation == 1
                                                "
                                                >Incorrect image format.Please
                                                upload the Png, Jpg, Jpeg, Svg,
                                                Pdf, Ai, Eps file formats</small
                                            >
                                            <small
                                                class="form-text text-error"
                                                v-if="
                                                    image_size_validation == 1
                                                "
                                                >Please upload images greater
                                                than 1000px X 1000px</small
                                            >
                                        </div>

                                        <div
                                            class="form-check brand_logo_img col-md-6"
                                        >
                                            <label
                                                v-if="
                                                    getUrlExtension(
                                                        croppieImage
                                                    ) == 'pdf'
                                                "
                                                class="checkbox_custom d-flex justify-content-center align-items-center px-0 w-100 align-item-center text-center"
                                            >
                                                <a
                                                    :href="croppieImage"
                                                    target="_blank"
                                                >
                                                    <img
                                                        src="/maincss/images/pdf.svg"
                                                        alt="pdf"
                                                        width="100%"
                                                        height="100%"
                                                    />
                                                </a>
                                            </label>
                                            <label
                                                v-else-if="
                                                    getUrlExtension(
                                                        croppieImage
                                                    ) == 'ai'
                                                "
                                                class="checkbox_custom d-flex justify-content-center align-items-center px-0 w-100 align-item-center text-center"
                                            >
                                                <a
                                                    :href="croppieImage"
                                                    target="_blank"
                                                >
                                                    <img
                                                        src="/maincss/images/ai_format_image.png"
                                                        alt="postscript"
                                                        width="100%"
                                                        height="100%"
                                                    />
                                                </a>
                                            </label>
                                            <label
                                                v-else-if="
                                                    getUrlExtension(
                                                        croppieImage
                                                    ) == 'eps'
                                                "
                                                class="checkbox_custom d-flex justify-content-center align-items-center px-0 w-100 align-item-center text-center"
                                            >
                                                <a
                                                    :href="croppieImage"
                                                    target="_blank"
                                                >
                                                    <img
                                                        src="/maincss/images/eps_formate_image.png"
                                                        alt="postscript"
                                                        width="100"
                                                        height="100"
                                                    />
                                                </a>
                                            </label>
                                            <label
                                                v-else
                                                class="checkbox_custom d-flex justify-content-center align-items-center px-0 w-100 align-item-center text-center"
                                            >
                                                <img
                                                    :src="
                                                        croppieImage
                                                            ? croppieImage
                                                            : '/maincss/design-studio/img/design-st-upload.jpg'
                                                    "
                                                    class
                                                    alt="Size Chart Logo"
                                                />
                                            </label>
                                        </div>
                                    </div>

                                    <small
                                        class="form-text text-error text-left"
                                        v-show="errors.has('uploadform.image')"
                                    >
                                        {{ errors.first("uploadform.image") }}
                                    </small>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button
                                    style="
                                        background-color: #f2790c !important;
                                        color: #fff !important;
                                        border: 1px solid #f2790c !important;
                                    "
                                    class="btn btn_outline_primary border_primary_blue text_primary_blue apply_upload"
                                    id="crop_btn"
                                    type="button"
                                    @click="crop"
                                >
                                    <img
                                        src="/maincss/images/upload-white.svg"
                                        alt=" "
                                    />
                                    Upload
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- START DESIGNING POPUP -->
                <div
                    class="modal fade h-auto login-form-popup"
                    id="design-confirmation-modal"
                    tabindex="-1"
                    aria-hidden="true"
                    data-keyboard="false"
                    data-backdrop="static"
                >
                    <div
                        class="modal-dialog modal-dialog-centered upload-artwork"
                    >
                        <div class="modal-content">
                            <div class="modal-body">
                                <a
                                    href="#"
                                    class="popup-close art_poup_close"
                                    id="popup-close"
                                    data-dismiss="modal"
                                >
                                    <img
                                        src="/maincss/images/cancel.svg"
                                        v-tooltip="'Close'"
                                        alt=" "
                                    />
                                </a>
                                <div class="login-form">
                                    <h3>Start Designing</h3>
                                    <p class="upload_design_p">
                                        Your selected Artwork will be removed if
                                        you will design this product, Are you
                                        sure?
                                    </p>
                                    <div class="upload_design">
                                        <div
                                            class="d-flex justify-content-center mb_20 start_design_btn_box"
                                        >
                                            <button
                                                class="btn btn_orange bg_primary_orange text_white mx_6"
                                                type="button"
                                                @click="startDesign()"
                                            >
                                                Continue
                                            </button>
                                            <a
                                                href="javascript:void(0)"
                                                class="btn btn_outline_primary border_primary_blue text_primary_blue mx_6"
                                                data-dismiss="modal"
                                                >Cancel</a
                                            >
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- PREVIEW MODEL -->
                <div
                    v-if="
                        getUrlExtension(preview_artwork_images) != 'ai' &&
                        getUrlExtension(preview_artwork_images) != 'eps'
                    "
                    class="modal fade cart_preview"
                    id="preview_modals"
                    data-backdrop="static"
                    data-keyboard="false"
                    tabindex="-1"
                    aria-labelledby="staticBackdropLabel"
                    aria-hidden="true"
                >
                    <div
                        class="modal-dialog modal-dialog-centered modal-xl large_popup"
                    >
                        <div class="modal-content">
                            <div class="modal-header border-bottom-0 p-0">
                                <button
                                    @click="cancelPreviewImages"
                                    type="button"
                                    class="close py-2 pr-3"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <img src="/maincss/images/cancel.svg" />
                                </button>
                            </div>
                            <!-- <img v-else alt="" :id="`default-artwork-${index}`" src="/maincss/images/mug_2.png" /> -->
                            <div class="modal-body pt-0">
                                <div
                                    v-if="
                                        getUrlExtension(
                                            preview_artwork_images
                                        ) == 'pdf'
                                    "
                                    class="mx-auto preview-image mb_20"
                                >
                                    <!-- <img  :src="preview_artwork_images" alt="pdf"> -->
                                    <iframe
                                        :src="preview_artwork_images"
                                        width="500px"
                                        height="300px"
                                    ></iframe>
                                </div>
                                <div v-else class="mx-auto preview-image mb_20">
                                    <img :src="preview_artwork_images" alt="" />
                                </div>
                                <div class="mx-auto preview-image">
                                    <!-- <button class="btn btn_orange bg_primary_orange text_white" type="button" @click="downloadArtwork(item.NewOrderItemDecoration ? item.NewOrderItemDecoration.final_proof_image : '', 'FinalProofImage', index)">Download</button> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <div
            v-else-if="!isBusy"
            class="accessdenie border-0"
            style="background-color: #fff"
        >
            <div class="subhead page_404_box">
                <p class="mb_20">This product is no longer available</p>
                <router-link
                    class="btn btn_primary bg_primary_blue text_white"
                    :to="{ name: 'home' }"
                    >Back to home page</router-link
                >
            </div>
        </div>

        <section
            class="smilar_product pb-0 pt-0 smilar_product_align product_similar"
            v-if="companion_products.length > 0"
        >
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h2 class="heading2">Similar products</h2>
                    </div>
                </div>
                <div class="row mt_30">
                    <div
                        class="col-md-4 col-lg-2"
                        v-for="(similarproducts, index) in companion_products"
                        :key="index"
                    >
                        <div class="product">
                            <div
                                class="product_image position-relative d-flex justify-content-center align-items-center"
                            >
                                <router-link
                                    :to="{
                                        name: 'product_details_new',
                                        params: {
                                            id_of_product: similarproducts.id
                                        }
                                    }"
                                >
                                    <img
                                        v-if="!is_tshirt_24_hour"
                                        :src="
                                            similarproducts.product_default_image
                                        "
                                    />
                                    <img
                                        v-else
                                        :src="
                                            similarproducts.t_shirt_24_hour_image
                                        "
                                    />
                                </router-link>
                            </div>
                            <div class="product_content p-sm-0">
                                <h5 class="font_size_18">
                                    {{ similarproducts.product_number }}
                                </h5>
                                <p>
                                    {{
                                        similarproducts.Brand
                                            ? similarproducts.Brand.name
                                            : ""
                                    }}
                                </p>
                                <p>{{ similarproducts.name }}</p>
                                <p>
                                    <DisplayProductPrice
                                        :product="similarproducts"
                                    />
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <div class="preloader" v-show="isBusy">
            <div class="preloader-body">
                <svg width="40" height="40" viewBox="0 0 40 40">
                    <polygon
                        class="rect"
                        points="0 0 0 40 40 40 40 0"
                    ></polygon>
                </svg>
            </div>
        </div>
    </div>
</template>
<script>
import Fuse from "fuse.js";
import { mapGetters } from "vuex";
import ApiService from "@/common/api.service";
import DisplayProductPrice from "@/components/DisplayProductPriceNew";
import { SITE_URL } from "@/common/config";
import ImprintCityPriceBreakdown from "./components/ImprintCityPriceBreakdown.vue";
import PCNAPriceBreakdown from "./components/PCNAPriceBreakdown.vue";
import {
    FETCH_DECORATION_PRICES,
    FETCH_DECORATION_TEMPLATE
} from "@/store/actions.type";
export default {
    name: "ProductDetails",
    metaInfo() {
        return {
            title: this.product ? this.product.name : "",
            titleTemplate: "%s | Imprintcity",
            meta: [
                {
                    vmid: "title",
                    name: "title",
                    content: this.product
                        ? `${this.product.name} | Imprintcity`
                        : ""
                },
                {
                    vmid: "description",
                    name: "description",
                    content:
                        this.product && this.product.description
                            ? this.product.description.replace(/<[^>]+>/g, "")
                            : ""
                },
                {
                    vmid: "keywords",
                    name: "keywords",
                    content: this.product ? this.product.keywords : ""
                }
            ]
        };
    },
    components: {
        DisplayProductPrice,
        PCNAPriceBreakdown,
        ImprintCityPriceBreakdown
    },

    data() {
        return {
            croppieImage: "",
            image_width: "",
            images_name: "",
            image_height: "",
            preview_artwork_images: "",
            crop_image_validation: 0,
            image_size_validation: 0,
            temp_product_artwork: "",
            product_artwork: "",
            image_uploaded: null,
            uploadedImages: [],
            isHovering: false,
            isBusy: false,
            size_list: [],
            gender_age_list: [],
            imprint_colors_array_for_template: [],
            books: [
                {
                    author: "author 11",
                    title: "title 11"
                },
                {
                    author: "author 22",
                    title: "title 22"
                }
            ],
            default_imprint_colors: [
                {
                    id: 1,
                    value: "1-colors"
                },
                {
                    id: 2,
                    value: "2-colors"
                },
                {
                    id: 3,
                    value: "3-colors"
                },
                {
                    id: 4,
                    value: "4-colors"
                },
                {
                    id: 5,
                    value: "5-colors"
                },
                {
                    id: 6,
                    value: "6-colors"
                }
            ],
            imprintcityColors: [],
            imprint_locations: [],
            is_favorite_product: false,
            favorite_product: [],
            is_imprint_location: false,
            is_color_show_more: false,
            product: {},
            decoration_price_template_values: [],
            decoration_price_template_values_for_imprint: [],
            decoration_price_template_location2: [],
            product_color: [],
            is_active: false,
            is_active_bottom: false,
            qty: [],
            total_uantity: 0,
            total_cost: 0,
            companion_products: [],
            more_decoration_list: [],
            tier_list: [],
            hashcolor: [],
            color_size_qty: [],
            decoration_type: "",
            retail_price_without_price_template: 0,
            main_retail_price: 0,
            individual_cost: 0,
            option_value: false,
            productTypeName: "",
            productTypePath: "apparel",
            listConfig: {
                offset: (this.currentPage - 1) * this.itemsPerPage,
                limit: this.itemsPerPage,
                sortBy: "",
                order: "ASC",
                brandIds: [],
                gender_age_ids: [],
                searchKeyword: ""
            },
            temp_img: {},
            images: {
                thumbs: [
                    {
                        id: 1,
                        url: "https://cdnp.sanmar.com/medias/sys_master/images/images/h54/h48/10361961709598/2870-AquaticBlue-1-29MAquaticBlueModelFront1-1200W.jpg"
                    },
                    {
                        id: 2,
                        url: "https://cdnp.sanmar.com/medias/sys_master/images/images/h54/h48/10361961709598/2870-AquaticBlue-1-29MAquaticBlueModelFront1-1200W.jpg"
                    }
                ],
                normal_size: [
                    {
                        id: 1,
                        url: "https://cdnp.sanmar.com/medias/sys_master/images/images/h54/h48/10361961709598/2870-AquaticBlue-1-29MAquaticBlueModelFront1-1200W.jpg"
                    },
                    {
                        id: 2,
                        url: "https://cdnp.sanmar.com/medias/sys_master/images/images/h54/h48/10361961709598/2870-AquaticBlue-1-29MAquaticBlueModelFront1-1200W.jpg"
                    }
                ]
            },
            zoomerOptions: {
                zoomFactor: 3, // scale for zoomer
                pane: "pane", // three type of pane ['pane', 'container-round', 'container']
                hoverDelay: 300, // how long after the zoomer take effect
                namespace: "zoomer", // add a namespace for zoomer component, useful when on page have mutiple zoomer
                move_by_click: false, // move image by click thumb image or by mouseover
                scroll_items: 500, // thumbs for scroll
                choosed_thumb_border_color: "#bbdefb", // choosed thumb border color
                scroller_button_style: "line",
                scroller_position: "left",
                zoomer_pane_position: "right"
            },
            //gender groups
            gender_groups: [],
            groupedSizesByColors: [], //sizes grouped by color
            colors: [], //colors list from sub products
            sizesby_selected_color: [], //sizes list according to selected color
            selected_color: "",
            setup_fee: false,
            setup_fee_applied_gender_index: -1,
            design_fee: 0,
            cart_items: [],
            current_cart_quantity: 0,
            choose_imprint_locations: false,
            max_cart_count: 2000,
            error_message: "",
            all_quantity: 0,
            disable_btns: true,
            temp_decoration_services: null,
            decoration_services: [],
            decoration_services_show: false,
            decoration_methods: [],
            print_templates_id: null,
            embroidery_template_ids: null,
            promotional_template_ids: null,
            decoration_method_template_ids: [],
            xl_has_quantity: false,
            site_url: "",
            current_product_type: null,
            same_artwork_cart_items: [],
            default_selected_color: null,
            start_designing_with: "scratch",
            minimum_quantity_decoration_fee: 0,
            print_areas: [],
            markup_tiers: [],
            is_tshirt_24_hour: false,
            total_decoration_colors_count: 0,
            per_color_setup_cost: 0,
            otherServices: [],
            currentBreakdown: {
                baseCost: 0,
                runCharge: 0,
                setupFee: 0,
                totalCost: 0,
                totalDiscount: 0,
                designFee: 0
            }
        };
    },

    created() {
        const maxDimensionsRule = {
            getMessage(field, [width, height], data) {
                return (
                    (data && data.message) ||
                    `The ${field} field must be up to ${width} pixels by ${height} pixels.`
                );
            },
            validate(files, [width, height]) {
                const validateImage = (file, width, height) => {
                    const URL = window.URL || window.webkitURL;
                    return new Promise((resolve) => {
                        const image = new Image();
                        image.onerror = () => resolve({ valid: false });
                        image.onload = () =>
                            resolve({
                                valid:
                                    image.width <= Number(width) &&
                                    image.height <= Number(height) // only change from official rule
                            });

                        image.src = URL.createObjectURL(file);
                    });
                };
                const list = [];
                for (let i = 0; i < files.length; i++) {
                    // if file is not an image, reject.
                    if (!/\.(jpg|jpeg|png)$/i.test(files[i].name)) {
                        return false;
                    }
                    list.push(files[i]);
                }
                return Promise.all(
                    list.map((file) => validateImage(file, width, height))
                );
            }
        };

        this.$validator.extend("maxdimensions", maxDimensionsRule);
    },

    beforeMount() {
        this.is_tshirt_24_hour = this.$route.name == "24hoursTShirts";
    },

    mounted() {
        /* eslint-disable */
        $("#crop_btn").prop("disabled", true);
        $(".cr-slider").prop("disabled", true);
        document.body.classList.remove("bg_primary_light_white");
        var _this = this;

        _this.getSingleProductData();
        _this.getTiers();
        _this.activeLink(0);

        if (this.isAuthenticatedClient) {
            // setTimeout(function () { _this.UploadedImages() }, 2000);
            // _this.getCartItems();
        }
        $(document).on("hide.bs.modal", "#add-art-work", function () {
            _this.$validator.reset();
            _this.image_uploaded = null;
            if (_this.$refs.fileInput) {
                _this.$refs.fileInput.value = null;
            }
            //Do stuff here
        });
        /* eslint-enable */
        this.site_url = SITE_URL;
    },

    computed: {
        ...mapGetters([
            "isAuthenticatedClient",
            "currentUserClient",
            "decorationPrices",
            "decorationTemplate",
            "printTemplates",
            "embroideryTemplates",
            "isAdminLoggedIn"
        ]),
        isPreviewMode() {
            return this.$route.name === "product_details_preview";
        },
        activeDecorationService() {
            // ADD THIS COMPUTED PROPERTY
            if (
                !this.decoration_services ||
                this.decoration_services.length === 0
            ) {
                return null;
            }
            return this.decoration_services.find((s) => s.isActive);
        },
        minimumOrderQuantity() {
            // Get first quantity from price_decoration_bulk
            if (
                !this.activeDecorationService ||
                !this.activeDecorationService.price_decoration_bulk
            ) {
                // Fallback to default values if no price data
                if (
                    this.product.decoration_type === 0 ||
                    this.product.decoration_type === 1
                ) {
                    return 12;
                } else if (this.product.decoration_type === 2) {
                    return 1;
                }
                return 12;
            }

            const service = this.activeDecorationService;
            let priceData;
            let firstQuantity = null;

            if (service.use_imprintcity_price_template === 0) {
                // New PCNA pricing structure
                priceData = service.price_decoration_bulk;
                if (Array.isArray(priceData) && priceData.length > 0) {
                    firstQuantity = priceData[0].quantity;
                }
            } else {
                // Old Imprint City template pricing structure
                const isPrint = this.decoration_type == 1;

                if (isPrint) {
                    priceData = Array.isArray(service.price_decoration_bulk)
                        ? service.price_decoration_bulk
                        : service.price_decoration_bulk.print_location1;
                } else {
                    // Embroidery
                    priceData = service.price_decoration_bulk;
                }

                if (Array.isArray(priceData) && priceData.length > 0) {
                    firstQuantity =
                        priceData[0].quantity || priceData[0].quantity1;
                }
            }

            // Return the first quantity if found, otherwise fallback to defaults
            if (firstQuantity !== null && firstQuantity !== undefined) {
                return firstQuantity;
            }

            // Fallback to default values
            if (
                this.product.decoration_type === 0 ||
                this.product.decoration_type === 1
            ) {
                return 12;
            } else if (this.product.decoration_type === 2) {
                return 1;
            }
            return 12;
        },
        activeProductDiscount() {
            const discount = this.product.MainNewProductDiscount;

            // Return null if there's no discount or its status is inactive
            if (!discount || !discount.status) {
                return null;
            }

            const today = new Date();
            // Set time to the beginning of the day for a consistent date-only comparison
            today.setHours(0, 0, 0, 0);

            // Check if the discount has a start date and if it has already started
            if (discount.start_date) {
                const startDate = new Date(discount.start_date);
                if (today < startDate) {
                    return null; // Discount hasn't started yet
                }
            }

            // Check if the discount has an end date and if it has expired
            if (discount.end_date) {
                const endDate = new Date(discount.end_date);
                if (today > endDate) {
                    return null; // Discount has expired
                }
            }

            // If all checks pass, the discount is active
            return discount;
        },

        priceTableData() {
            if (
                !this.activeDecorationService ||
                !this.activeDecorationService.price_decoration_bulk
            ) {
                return [];
            }

            const service = this.activeDecorationService;
            let priceData;

            if (service.use_imprintcity_price_template === 0) {
                priceData = service.price_decoration_bulk;
                if (
                    !priceData ||
                    !Array.isArray(priceData) ||
                    priceData.length === 0
                ) {
                    return [];
                }
                let useRetailEqp = false;
                if (
                    this.product &&
                    this.product.Decorators &&
                    this.product.default_decorator_id
                ) {
                    const defaultDecorator = this.product.Decorators.find(
                        (decorator) =>
                            decorator.id === this.product.default_decorator_id
                    );

                    if (defaultDecorator) {
                        useRetailEqp = defaultDecorator.use_retail_eqp;
                    }
                }

                if (useRetailEqp) {
                    const lastTier = priceData[priceData.length - 1];
                    const retailCost = parseFloat(lastTier.retail_cost || 0);
                    const discount = parseFloat(lastTier.discount || 0);
                    const finalNetCost = retailCost * (1 - discount / 100);

                    return priceData.map((item) => ({
                        quantity: item.quantity,
                        retail_cost: parseFloat(item.retail_cost || 0),
                        net_cost: finalNetCost
                    }));
                } else {
                    return priceData.map((item) => {
                        const retail = parseFloat(item.retail_cost || 0);
                        const discount = parseFloat(item.discount || 0);
                        const net = retail * (1 - discount / 100);
                        return {
                            quantity: item.quantity,
                            retail_cost: retail,
                            net_cost: net
                        };
                    });
                }
            } else {
                const isPrint = this.decoration_type == 1;

                if (isPrint) {
                    priceData = Array.isArray(service.price_decoration_bulk)
                        ? service.price_decoration_bulk
                        : service.price_decoration_bulk.print_location1;
                } else {
                    // Embroidery
                    priceData = service.price_decoration_bulk;
                }

                if (!priceData || !Array.isArray(priceData)) return [];

                return priceData.map((item) => {
                    const quantity = item.quantity || item.quantity1;
                    const decoration_cost = parseFloat(
                        item.cost || item.colour1 || 0
                    );
                    const decoration_discount_percent = parseFloat(
                        item.discount || 0
                    );

                    const decoration_discount_amount =
                        (decoration_cost * decoration_discount_percent) / 100;
                    const discounted_decoration_cost =
                        decoration_cost - decoration_discount_amount;

                    let markup_percentage =
                        service.markup_percentage ||
                        this.product.price_markup_percentage;
                    let markup_value =
                        (parseFloat(this.product.price_base || 0) *
                            parseFloat(markup_percentage)) /
                        100;

                    const color_category_price = this.getDarkLightFees(
                        this.default_selected_color
                    );

                    const final_retail_cost =
                        parseFloat(this.product.price_base || 0) +
                        markup_value +
                        discounted_decoration_cost +
                        color_category_price;

                    const net_cost =
                        parseFloat(this.product.price_base || 0) +
                        discounted_decoration_cost +
                        color_category_price;

                    return {
                        quantity: quantity,
                        retail_cost: final_retail_cost,
                        net_cost: net_cost
                    };
                });
            }
        }
    },
    methods: {
        // Prepare color-size combinations array for price breakdown
        getColorSizeCombinations(gender) {
            if (
                !gender ||
                !gender.selected_colors ||
                !Array.isArray(gender.selected_colors)
            ) {
                return [];
            }

            const combinations = [];

            gender.selected_colors.forEach((color) => {
                if (!color.unique_sizes || !Array.isArray(color.unique_sizes)) {
                    return;
                }

                color.unique_sizes.forEach((size) => {
                    // Only include sizes with quantity > 0
                    if (size.quantity && parseInt(size.quantity) > 0) {
                        // Extract only size abbreviation (XS, S, M, L, XL, etc.)
                        let sizeAbbr = "N/A";
                        if (size.size_name) {
                            sizeAbbr = size.size_name;
                        } else if (size.size) {
                            // If size contains full product name, extract last word (size abbreviation)
                            const sizeParts = size.size.trim().split(/\s+/);
                            sizeAbbr = sizeParts[sizeParts.length - 1];
                        } else if (size.name) {
                            // If name contains full product name, extract last word (size abbreviation)
                            const nameParts = size.name.trim().split(/\s+/);
                            sizeAbbr = nameParts[nameParts.length - 1];
                        }

                        // Get color value and ensure it has # prefix
                        // Try multiple possible property names: color_value, hex, hash
                        let colorValue =
                            color.color_value || color.hex || color.hash || "";
                        if (colorValue && !colorValue.startsWith("#")) {
                            colorValue = "#" + colorValue;
                        }
                        if (!colorValue) {
                            colorValue = "#cccccc";
                        }

                        combinations.push({
                            color_id: color.id || color.color_id,
                            color_name:
                                color.name || color.color_name || "Color",
                            color_value: colorValue,
                            hex: colorValue,
                            size: sizeAbbr,
                            quantity: parseInt(size.quantity) || 0,
                            cost: parseFloat(size.cost) || 0,
                            total_cost: parseFloat(size.total_cost) || 0
                        });
                    }
                });
            });

            return combinations;
        },
        filterOtherServices() {
            if (!this.product || !this.product.VendorOtherServices) {
                this.otherServices = [];
                return;
            }
            const activeService = this.activeDecorationService;
            if (!activeService || !activeService.other_services_list) {
                this.otherServices = [];
                return;
            }
            const applicableServices = activeService.other_services_list;
            if (
                !Array.isArray(applicableServices) ||
                applicableServices.length === 0
            ) {
                this.otherServices = [];
                return;
            }
            const applicableServiceIds = applicableServices.map((s) => s.id);
            const filteredServices = this.product.VendorOtherServices.filter(
                (service) => applicableServiceIds.includes(service.id)
            );
            this.otherServices = filteredServices;
        },
        getPrintArea(product_type_id) {
            let _this = this;
            _this.isBusy = true;
            return new Promise((resolve, reject) => {
                ApiService.get("/product-types/" + product_type_id)
                    .then(({ data }) => {
                        if (data.product_type.canvas_design_areas) {
                            _this.print_areas = JSON.parse(
                                data.product_type.canvas_design_areas
                            );
                        }
                        _this.isBusy = false;
                        resolve(data);
                    })
                    .catch(({ response }) => {
                        console.log(response);
                        _this.isBusy = false;
                        reject(response);
                    });
            });
        },
        getSingleProductData() {
            var _this = this;
            _this.isBusy = true;
            new Promise(() => {
                ApiService.get(
                    "/home-single-newproduct-new/" +
                        this.$route.params.id_of_product
                )
                    .then(async ({ data }) => {
                        if (data.success == true && data.product != null) {
                            await this.getAllMarkupTiers();
                            await this.getDecorationMethods();

                            if (
                                JSON.parse(data.product.design_areas).length > 0
                            ) {
                                await this.getPrintArea(
                                    data.product.product_type_id
                                );
                                this.resetImprintLocations(
                                    JSON.parse(data.product.design_areas)
                                );
                            }

                            _this.decoration_services_show = true;

                            let decorations = JSON.parse(
                                data.product.decorations
                            );
                            _this.decoration_services = [];
                            // Check if the new structure exists
                            if (
                                decorations &&
                                decorations.length > 0 &&
                                decorations[0].decoration_type_list
                            ) {
                                // Find the default service object first
                                const defaultService =
                                    decorations[0].decoration_type_list.find(
                                        function (service) {
                                            // Correctly check if the service's ID matches the is_default value
                                            return (
                                                service.is_default === 1 ||
                                                service.is_default === true ||
                                                service.is_default === "1"
                                            );
                                        }
                                    );
                                // Then, safely get its ID only if it was found
                                const defaultServiceId = defaultService
                                    ? defaultService.id
                                    : null;

                                decorations[0].decoration_type_list.forEach(
                                    function (service) {
                                        // Push each available service into the decoration_services array
                                        _this.decoration_services.push({
                                            id: service.id, // Use the specific service ID
                                            decoration_type:
                                                service.decoration_type,
                                            decoration_price_template:
                                                service.selected_pricing_template_id,
                                            name: service.name,
                                            more_decorations:
                                                service.more_decoration,
                                            other_services_list:
                                                service.other_service,
                                            price_decoration_bulk:
                                                service.price_decoration_bulk,
                                            // Set 'isActive' to true if this service is the default one
                                            isActive:
                                                service.id === defaultServiceId,
                                            price_dark: service.price_dark || 0,
                                            price_light:
                                                service.price_light || 0,
                                            use_imprintcity_price_template:
                                                service.use_imprintcity_price_template,
                                            master_service:
                                                service.master_service,
                                            max_colors: service.max_colors,
                                            markup_percentage:
                                                service.markup_percentage || 0,
                                            is_full_color:
                                                service.is_full_color || false,
                                            full_color: service.full_color || 0
                                        });

                                        // Store template IDs for later use if needed
                                        if (service.decoration_type == "1") {
                                            _this.print_templates_id =
                                                service.selected_pricing_template_id;
                                        }
                                        if (service.decoration_type == "2") {
                                            _this.embroidery_template_ids =
                                                service.selected_pricing_template_id;
                                        }
                                        if (service.decoration_type == "3") {
                                            _this.promotional_template_ids =
                                                service.selected_pricing_template_id;
                                        }
                                    }
                                );
                            }

                            _this.temp_decoration_services = JSON.parse(
                                JSON.stringify(_this.decoration_services)
                            );
                            const initialActiveServiceIndex =
                                _this.decoration_services.findIndex(
                                    (s) => s.isActive
                                );

                            // Assign product and fetch prices before calling changeDecorationService
                            var thumb_array = [];
                            var normal_array = [];

                            if (this.is_tshirt_24_hour) {
                                data.product.MainNewSubProducts =
                                    data.product.MainNewSubProducts.filter(
                                        (sub_product_data) =>
                                            sub_product_data.Color.name ==
                                            "White"
                                    );
                            }

                            _this.product = data.product; // ASSIGNED EARLY

                            _this.product.price_decoration_bulk = JSON.parse(
                                _this.product.price_decoration_bulk
                            );
                            this.filterOtherServices(); // This will be handled by changeDecorationService

                            // FETCHING LATEST PRICES FROM DECORATION TEMPLATES
                            if (
                                data.product.decoration_price_type ==
                                "global_price"
                            ) {
                                await this.$store
                                    .dispatch(FETCH_DECORATION_PRICES, {
                                        decoration_type:
                                            data.product.decoration_type,
                                        decoration_price_template_id:
                                            data.product
                                                .decoration_price_template
                                    })
                                    .then(() => {
                                        _this.product.price_decoration_bulk =
                                            _this.decorationPrices;
                                    });
                                if (
                                    _this.product.decoration_type === 1 &&
                                    _this.product.PrintTemplate
                                ) {
                                    _this.product.price_decoration_bulk.no_of_colors =
                                        _this.product.PrintTemplate.no_of_colors;
                                    _this.product.price_color_category_dark =
                                        _this.product.PrintTemplate.price_dark;
                                    _this.product.price_color_category_light =
                                        _this.product.PrintTemplate.price_light;
                                } else if (
                                    _this.product.decoration_type === 2 &&
                                    _this.product.Embroidery
                                ) {
                                    _this.product.price_color_category_dark =
                                        _this.product.Embroidery.price_dark;
                                    _this.product.price_color_category_light =
                                        _this.product.Embroidery.price_light;
                                }
                            }

                            if (initialActiveServiceIndex !== -1) {
                                _this.changeDecorationService(
                                    initialActiveServiceIndex,
                                    true
                                );
                            }

                            _this.product.more_decoration = JSON.parse(
                                _this.product.more_decoration
                            );
                            let sorted_size_names = this.sizesArrangmentSorting(
                                _this.product.MainNewSubProducts.map(
                                    (s) => s.Size.size
                                )
                            );
                            let sorted_sub_products = [];
                            sorted_size_names.forEach((sorted_size_name) => {
                                _this.product.MainNewSubProducts.forEach(
                                    (new_sub_product) => {
                                        if (
                                            new_sub_product.Size.size ==
                                            sorted_size_name
                                        ) {
                                            sorted_sub_products.push(
                                                new_sub_product
                                            );
                                        }
                                    }
                                );
                            });
                            _this.product.MainNewSubProducts =
                                sorted_sub_products;

                            //if video url in product table
                            if (
                                data.product.video_url &&
                                data.product.video_url.trim() != ""
                            ) {
                                thumb_array.push({
                                    id: data.product.id,
                                    url: data.product.video_url,
                                    thumb_url: data.product.video_url,
                                    type: "video"
                                });
                                normal_array.push({
                                    id: data.product.id,
                                    url: data.product.video_url,
                                    type: "video"
                                });
                            }

                            //decoration type
                            _this.decoration_type =
                                data.product.decoration_type;
                            this.loadVendorColors(data.product);

                            //gender and colors
                            _this.groupedSizesByColors =
                                _this.groupArrayOfObjects(
                                    _this.product.MainNewSubProducts,
                                    "color_id"
                                );
                            Object.values(_this.groupedSizesByColors).forEach(
                                (element) => {
                                    let lowest_price = 0;
                                    element.forEach((size, i) => {
                                        let base_price = size.price_base
                                            ? size.price_base
                                            : 0;
                                        if (parseFloat(base_price) > 0) {
                                            if (i == 0) {
                                                lowest_price =
                                                    parseFloat(base_price);
                                            } else if (
                                                parseFloat(lowest_price) >
                                                parseFloat(base_price)
                                            ) {
                                                lowest_price =
                                                    parseFloat(base_price);
                                            }
                                        }
                                    });
                                    _this.colors.push({
                                        id: element[0].Color.id,
                                        color_name: element[0].Color.name,
                                        hash: element[0].Color.hex,
                                        pms: element[0].Color.pms,
                                        swatches: element[0].Color.swatches,
                                        shades: element[0].Color.shades,
                                        category: element[0].Color.category,
                                        default_selection:
                                            element[0].default_selection,
                                        price_base: lowest_price
                                    });
                                }
                            );

                            // STORE DEFAULT COLOR
                            if (!this.is_tshirt_24_hour) {
                                _this.default_selected_color =
                                    _this.colors.find(
                                        (color) => color.default_selection == 1
                                    );
                            } else {
                                _this.default_selected_color = _this.colors[0];
                            }

                            _this.product.price_base =
                                _this.default_selected_color.price_base;
                            _this.product.price_markup_value =
                                (parseFloat(_this.product.price_base) *
                                    parseFloat(
                                        _this.product.price_markup_percentage
                                    )) /
                                100;

                            _this.retail_price_without_price_template =
                                _this.product.price_base +
                                _this.product.price_markup_value;

                            //    Decoration
                            this.prepareDecorationPrices(
                                this.product.decoration_type,
                                this.product.price_decoration_bulk
                            );

                            await _this.getMoreDecorations(
                                _this.product.more_decoration
                            );

                            if (!_this.is_tshirt_24_hour) {
                                await _this.getProductImages();
                            } else {
                                await _this.getProductImages(
                                    _this.colors[0].id
                                );
                            }

                            // if (_this.decoration_method_template_ids) {
                            //     _this.getDecorationPriceFromTemplateIds();
                            // }

                            //genders group (normalize to array of ids)
                            let gendersGroupRaw = data.product.size_groupings;
                            let gendersGroup;
                            try {
                                if (
                                    typeof gendersGroupRaw === "string" &&
                                    (gendersGroupRaw.trim().startsWith("[") ||
                                        gendersGroupRaw
                                            .trim()
                                            .startsWith('"') ||
                                        gendersGroupRaw.trim().startsWith("{"))
                                ) {
                                    gendersGroup = JSON.parse(gendersGroupRaw);
                                } else if (
                                    typeof gendersGroupRaw === "string" &&
                                    gendersGroupRaw.trim() !== ""
                                ) {
                                    // plain id string like "54"
                                    gendersGroup = [
                                        Number(gendersGroupRaw.trim())
                                    ];
                                } else if (
                                    typeof gendersGroupRaw === "number"
                                ) {
                                    gendersGroup = [gendersGroupRaw];
                                } else if (Array.isArray(gendersGroupRaw)) {
                                    gendersGroup = gendersGroupRaw;
                                } else {
                                    gendersGroup = [];
                                }
                            } catch (e) {
                                // fallback for invalid JSON
                                if (
                                    typeof gendersGroupRaw === "string" &&
                                    gendersGroupRaw.trim() !== ""
                                ) {
                                    gendersGroup = [
                                        Number(gendersGroupRaw.trim())
                                    ];
                                } else {
                                    gendersGroup = [];
                                }
                            }
                            // ensure array of numbers
                            gendersGroup = (gendersGroup || [])
                                .map((v) => Number(v))
                                .filter((v) => !isNaN(v));

                            await _this.getGendersGroups(gendersGroup);

                            // Wait for Vue to update the DOM with the new gender groups and colors
                            await _this.$nextTick();

                            // Now that the DOM is rendered, safely click the default color
                            if (_this.default_selected_color) {
                                const defaultColorEl = document.getElementById(
                                    `gender_${this.gender_groups[0].id}_color_${_this.default_selected_color.id}`
                                );
                                if (defaultColorEl) {
                                    defaultColorEl.click();
                                } else {
                                    console.error(
                                        "Could not find default color element to click."
                                    );
                                }
                            }
                            _this.isBusy = false;
                            _this.getCompanionProduct(
                                this.$route.params.id_of_product
                            );
                        }
                    })
                    .catch((response) => {
                        _this.isBusy = false;
                        console.log(response);
                        this.$toast.error(response, {
                            position: "top-right",
                            queue: true
                        });
                    });
            });
        },

        updateDecorationDiscountedPrice(data, decoration_type) {
            if (decoration_type == 1) {
                if (data.print_location1) {
                    data.print_location1.forEach((row) => {
                        for (
                            let i = 1;
                            i < this.product.PrintTemplate.no_of_colors;
                            i++
                        ) {
                            let discount_colour =
                                (parseFloat(row[`colour${i}`]) *
                                    parseFloat(row.discount)) /
                                100;
                            row[`colour${i}`] = parseFloat(
                                parseFloat(row[`colour${i}`]) -
                                    parseFloat(discount_colour)
                            ).toFixed(2);
                        }
                    });
                }
            } else if (decoration_type == 2) {
                data.forEach((row) => {
                    let discount_value =
                        (parseFloat(row["cost"]) * parseFloat(row.discount)) /
                        100;
                    row["cost"] = parseFloat(
                        parseFloat(row["cost"]) - parseFloat(discount_value)
                    ).toFixed(2);
                });
            }
            return data;
        },

        deleteImages(image_id) {
            let ids = [];
            if (confirm("Do you really want to delete?")) {
                new Promise(() => {
                    ids.push(image_id);
                    ApiService.post("/delete_userimages", { ids: ids })
                        .then(() => {
                            this.uploadedImages = [];
                            this.UploadedImages();
                            /* eslint-disable */
                            $(".new_artwork_popup").modal("hide");
                            /* eslint-enable */
                            this.$toast.success("Image deleted successfully", {
                                position: "top-right",
                                queue: true
                            });
                        })
                        .catch(({ response }) => {
                            //  console.log(response.status);
                            if (response.status == 401) {
                                this.$router.push({ name: "/client/login" });
                            }
                        });
                });
            }
        },

        previewArtworkImages(images) {
            this.preview_artwork_images = images;
            /* eslint-disable */
            if (
                this.getUrlExtension(images) == "ai" ||
                this.getUrlExtension(images) == "eps"
            ) {
                $("#preview_modals").modal("hide");
                // window.open(this.preview_artwork_images, '_blank');
                this.downloadURI(this.preview_artwork_images, this.images_name);
                this.$toast.success("Files downloaded successfully", {
                    position: "top-right",
                    queue: true
                });
                return;
            }
            $("#add-art-work").modal("hide");
            /* eslint-enable */
        },

        cancelPreviewImages() {
            /* eslint-disable */
            $("#add-art-work").modal("show");
            /* eslint-enable */
        },

        downloadURI(uri, name) {
            var link = document.createElement("a");
            link.download = name;
            link.href = uri;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },

        getsizeByColor(color_obj, event = null) {
            if (!event || !event.target.checked) {
                let selected_colors =
                    this.gender_groups[this.is_active]["selected_colors"];

                if (selected_colors && selected_colors.length) {
                    this.gender_groups[this.is_active]["selected_colors"] =
                        selected_colors.filter(
                            (color) => color.id != color_obj.id
                        );
                    let color_index = this.colors.findIndex(
                        (color) => color.id == color_obj.id
                    );
                    this.colors[color_index].is_selected = false;
                }

                if (
                    this.gender_groups[this.is_active].total_qty_gender_wise ==
                        0 &&
                    selected_colors.length == 0
                ) {
                    this.resetValues();
                }

                if (
                    this.gender_groups[this.is_active]["selected_colors"]
                        .length == 0
                ) {
                    this.choose_imprint_locations = false;
                    this.resetImprintLocations(
                        JSON.parse(this.product.design_areas)
                    );
                }

                this.calculatePricing(this.is_active);
                this.onChangeGenderColor();
                this.$forceUpdate();

                return;
            }

            let image = this.product.NewProductImages.find(
                (productImage) => productImage.color_id == color_obj.id
            );

            if (image && image.url) {
                color_obj["product_image"] = image.url;
            }

            this.selected_color = color_obj;
            let selected_gender = this.gender_groups[this.is_active];
            let sizes = [];
            sizes.push(
                selected_gender.sizes.filter(function (size) {
                    return size.color_id === color_obj.id;
                })
            );
            let sizesby_selected_color = [].concat.apply([], sizes);
            let new_sizeby_selected_color_array = [];
            sizesby_selected_color.forEach((element) => {
                if (element.status) {
                    new_sizeby_selected_color_array.push(element);
                }
            });
            this.sizesby_selected_color = new_sizeby_selected_color_array;

            let colorObj = JSON.parse(JSON.stringify(color_obj));

            let defaultCost = 0;
            const activeService = this.activeDecorationService;

            if (
                activeService &&
                activeService.price_decoration_bulk &&
                Array.isArray(activeService.price_decoration_bulk) &&
                activeService.price_decoration_bulk.length > 0
            ) {
                defaultCost = parseFloat(
                    activeService.price_decoration_bulk[0].retail_cost || 0
                );
            }

            let unique_sizes_with_cost = JSON.parse(
                JSON.stringify(this.sizesby_selected_color)
            );
            unique_sizes_with_cost.forEach((size) => {
                size.cost = defaultCost;
                size.total_cost = 0;
            });
            colorObj["unique_sizes"] = unique_sizes_with_cost;

            colorObj["total_cost_gender_wise"] = 0;
            colorObj["total_qty_gender_wise"] = 0;
            colorObj["total_color_fee"] = 0;
            colorObj["total_dark_category_fee"] = 0;
            colorObj["total_light_category_fee"] = 0;
            colorObj["total_decoration_discount_value"] = 0;
            if (!this.gender_groups[this.is_active]["selected_colors"]) {
                this.gender_groups[this.is_active]["selected_colors"] = [
                    colorObj
                ];
            } else {
                let color_index = this.gender_groups[this.is_active][
                    "selected_colors"
                ].findIndex((color) => color.id == colorObj.id);
                if (color_index < 0) {
                    this.gender_groups[this.is_active]["selected_colors"].push(
                        colorObj
                    );
                }
            }

            if (
                this.gender_groups[this.is_active]["selected_colors"].length > 0
            ) {
                this.choose_imprint_locations = true;
            }

            this.calculatePricing(this.is_active);

            this.onChangeGenderColor();
        },

        fuseSearch(options, search) {
            const fuse = new Fuse(options, {
                keys: ["color_name", "color_value"],
                shouldSort: true
            });
            return search.length
                ? fuse.search(search).map(({ item }) => item)
                : fuse.list;
        },

        //croppie function start
        bind() {
            // Randomize cat photos, nothing special here.
            /* eslint-disable */
            let url = this.images[Math.floor(Math.random() * 4)];
            /* eslint-enable */
            // Just like what we did with .bind({...}) on
            // the mounted() function above.
            this.$refs.croppieRef.bind({
                url: "/maincss/design-studio/img/design-st-upload.jpg",
                zoom: 0
            });
        },

        cropViaEvent() {
            /* eslint-disable */
            this.$refs.croppieRef.result(options);
            /* eslint-enable */
        },

        result(output) {
            this.cropped = output;
        },

        update(val) {
            console.log(val);
        },

        rotate(rotationAngle) {
            // Rotates the image
            this.$refs.croppieRef.rotate(rotationAngle);
        },

        croppie(e) {
            var _this = this;
            /* eslint-disable */
            $(".cr-slider").prop("disabled", false);
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;

            _this.image_size_validation = 0;
            this.image_size = files[0].size / (1024 * 1024);
            // console.log('check for svg images here==========', files[0]['type']);
            if (
                files[0]["type"] != "image/jpeg" &&
                files[0]["type"] != "image/png" &&
                files[0]["type"] != "image/jpg" &&
                files[0]["type"] != "image/svg+xml" &&
                files[0]["type"] != "application/pdf" &&
                files[0]["type"] != "application/postscript"
            ) {
                this.crop_image_validation = 1;
                console.log(
                    "Incorrect image format.Please upload the Png, Jpg, Jpeg, svg, pdf, ai, eps file formats"
                );
                $("#crop_bdr").val("");
                this.croppieImage = null;
                this.images_name = "";
                // this.$refs.croppieRef.refresh();

                //load default image in croptool
                // this.$refs.croppieRef.bind({
                //     url: '/maincss/design-studio/img/design-st-upload.jpg'
                // });
            } else {
                _this.crop_image_validation = 0;
                _this.image_size_validation = 0;

                var reader = new FileReader();
                reader.onload = (e) => {
                    var image = new Image();
                    image.src = e.target.result;
                    $(".cr-slider").prop("disabled", true);
                    $("#crop_btn").prop("disabled", false);
                    this.croppieImage = e.target.result;
                    this.images_name = files[0]["name"];
                    image.onload = function () {
                        _this.image_height = this.height;
                        _this.image_width = this.width;
                        if (
                            _this.image_height < 100 &&
                            _this.image_width < 100
                        ) {
                            _this.crop_image_validation = 0;
                        } else {
                            _this.image_height = "";
                            _this.image_width = "";
                            _this.image_size_validation = 0;
                        }
                    };
                };
            }
            /* eslint-enable */

            reader.readAsDataURL(files[0]);
        },

        crop() {
            // Options can be updated.
            // Current option will return a base64 version of the uploaded image with a size of 600px X 450px.
            this.image_width = 200;
            this.image_height = 200;
            this.image_uploaded = {
                image: this.croppieImage,
                name: this.images_name,
                size: this.image_size.toFixed(2) + "MB",
                dimension: this.image_width + "x" + this.image_height
            };
            this.uploadedImages.push({ image_path: this.croppieImage });
            if (this.uploadedImages.length == 1) {
                this.temp_product_artwork = this.croppieImage;
            }
            this.NewImageUploads();
            /* eslint-disable */
            $("#crop_modal").modal("hide");
            $("#crop_bdr").val("");
            $("#add-art-work").modal("show");
            /* eslint-enable */
        },

        uploadArtWork() {
            /* eslint-disable */
            let val = $("#crop_bdr").val();
            this.croppieImage = null;
            this.images_name = null;
            if (!val) {
                $("#crop_btn").prop("disabled", true);
            } else {
                $("#crop_btn").prop("disabled", false);
            }
            $("#add-art-work").modal("hide");
            /* eslint-enable */
        },

        cancelUploadArtwork() {
            /* eslint-disable */
            $("#add-art-work").modal("show");
            /* eslint-enable */
        },

        addArtWorkModal() {
            // let decoration_template;
            // if (this.decoration_type == 1) {
            //     decoration_template = this.decoration_price_template_values[0].quantity;
            // } else if (this.decoration_type == 2) {
            //     decoration_template = this.decoration_price_template_values[0].quantity1;
            // }
            // // let color_names = [];
            // let color_names = [];
            // let error = false;
            // let gender_total_quantity = 0;
            // this.gender_groups.forEach(gender => {
            //     gender.selected_colors.forEach(color => {
            //         if (!color.total_qty_gender_wise) {
            //             color_names.push(color.color_name)
            //             error = true;
            //         }
            //         // if (
            //         //     parseInt(color.total_qty_gender_wise) <
            //         //     parseInt(decoration_template)
            //         // ) {
            //         //     color_names.push(color.color_name)
            //         //     error = true;
            //         // }
            //     })
            //     gender_total_quantity+=gender.total_qty_gender_wise;
            // })

            // if (error) {
            //     // this.$toast.error(`${color_names.join(',')} quantity should be equal or greater than ${decoration_template}`, { position: "top-right", queue: true });
            //     this.$toast.error(`${color_names.join(',')}  atleast one single quantity is required`, { position: "top-right", queue: true });
            //     return;
            // }

            // if (gender_total_quantity < decoration_template) {
            //     this.$toast.error(`Quantity should be greater than or equal to ${decoration_template}`,  { position: "top-right", queue: true });
            //     return;
            // }
            /* eslint-disable */
            $("#add-art-work").modal("show");
            /* eslint-enable */
        },

        //croppie function end
        artworkDone() {
            if (this.temp_product_artwork) {
                this.product_artwork = this.temp_product_artwork;

                this.updateCartQuantity(true);
                return;
            }
            this.removeArtwork();

            this.updateCartQuantity(true);
        },

        removeArtwork() {
            this.product_artwork = "";
            this.temp_product_artwork = "";
            // this.removeSetupFee();
        },

        removeSetupFee() {
            if (this.setup_fee_applied_gender_index >= 0) {
                let gender =
                    this.gender_groups[this.setup_fee_applied_gender_index];
                if (gender.total_cost_gender_wise != 0) {
                    gender.total_cost_gender_wise =
                        parseFloat(gender.total_cost_gender_wise) -
                        gender["selected_colors"][0].setup_fee;
                    gender["selected_colors"][0].total_cost_gender_wise =
                        parseFloat(
                            gender["selected_colors"][0].total_cost_gender_wise
                        ) - gender["selected_colors"][0].setup_fee;
                }
                gender["selected_colors"][0].setup_fee = 0.0;
            }
            this.setup_fee = false;
            this.setup_fee_applied_gender_index = -1;
        },

        UploadedImages() {
            this.uploadedImages = [];
            new Promise(() => {
                ApiService.post("/userimages")
                    .then(({ data }) => {
                        this.uploadedImages = data.userImages.filter((image) =>
                            this.isValidHttpUrl(image.image_path)
                        );
                    })
                    .catch(({ response }) => {
                        //  console.log(response.status);
                        if (response.status == 401) {
                            this.$router.push({ name: "/client/login" });
                        }
                    });
            });
        },

        NewImageUploads() {
            if (this.image_uploaded) {
                var _this = this;
                _this.isBusy = true;
                new Promise(() => {
                    ApiService.post("/image_upload", this.image_uploaded)
                        .then(({ data }) => {
                            _this.isBusy = false;

                            if (data.success == false) {
                                _this.$toast.error(data.error, {
                                    position: "top-right",
                                    queue: true
                                });
                                return false;
                            }
                            _this.temp_product_artwork = data.image.image_path;
                            _this.image_uploaded = null;
                            if (_this.$refs.fileInput) {
                                _this.$refs.fileInput.value = null;
                            }
                            // _this.UploadedImages();
                            _this.artworkDone();
                            // $("#add-art-work").modal("hide");
                        })
                        .catch((response) => {
                            _this.isBusy = false;
                            _this.$toast.error(response, {
                                position: "top-right",
                                queue: true
                            });
                            console.log(response);
                            if (response.status == 401) {
                                this.$router.push({ name: "/client/login" });
                            }
                        });
                });
            }
        },

        resetValues() {
            this.removeArtwork();
            this.removeSetupFee();
            this.disable_btns = true;
            this.gender_groups.forEach((gender) => {
                gender["total_cost_gender_wise"] = 0.0;
                gender["selected_colors"] = [];
                gender["total_color_fee"] = 0.0;
                gender["total_qty_gender_wise"] = 0.0;
            });
            this.colors.forEach((color) => {
                color.is_selected = false;
            });

            this.imprint_locations = [];
            if (JSON.parse(this.product.design_areas).length > 0) {
                this.resetImprintLocations(
                    JSON.parse(this.product.design_areas)
                );
            }

            this.hashcolor = [];
            this.current_cart_quantity = 0;
        },

        resetImprintLocations(design_areas) {
            this.imprint_locations = [];
            design_areas.forEach((area) => {
                if (area.selected) {
                    let selectedArea = this.print_areas.filter((printArea) => {
                        return printArea.label == area.label;
                    });
                    this.imprint_locations.push({
                        location: area.label_show.trim() || area.label.trim(),
                        image_path:
                            selectedArea.length > 0
                                ? area.short_thumbnail_image
                                : selectedArea[0].short_thumbnail_image,
                        is_selected: false,
                        no_of_color: null,
                        price: 0,
                        total_price: 0,
                        colors: []
                    });
                }
            });
        },

        converToCamel(text) {
            return text.replace(
                /(^\w|\s\w)(\S*)/g,
                (_, m1, m2) => m1.toUpperCase() + m2.toLowerCase()
            );
        },

        // This function not using
        // addTocart() {
        //     var _this = this;

        //     let is_colors_empty = false;
        //     let is_locations_selected = false;
        //     let is_area_colors_empty = false;
        //     for (let location of _this.imprint_locations) {
        //         if (location.is_selected) {
        //             is_locations_selected = true;
        //             if (location.colors.length == 0) {
        //                 is_area_colors_empty = true;
        //                 break;
        //             } else {
        //                 let is_selected = location.colors.find(
        //                     (color) => color.color == null
        //                 );
        //                 if (is_selected) {
        //                     is_colors_empty = true;
        //                     break;
        //                 }
        //             }
        //         }
        //     }

        //     let errorText = "";
        //     if (_this.product.decoration_type == 1) {
        //         errorText = "imprint locations";
        //     } else if (_this.product.decoration_type == 2) {
        //         errorText = "embroidery locations";
        //     }

        //     if (!is_locations_selected) {
        //         _this.$toast.error(`Please select ${errorText}.`, {
        //             position: "top-right",
        //             queue: true
        //         });
        //         return;
        //     } else if (is_colors_empty) {
        //         _this.$toast.error(
        //             `Please select all imprint colors for selected ${errorText}.`,
        //             { position: "top-right", queue: true }
        //         );
        //         return;
        //     } else if (is_area_colors_empty) {
        //         _this.$toast.error(
        //             `Please select colors for selected ${errorText}.`,
        //             { position: "top-right", queue: true }
        //         );
        //         return;
        //     }

        //     if (!this.product_artwork) {
        //         _this.$toast.error("Please Select or Upload Artwork", {
        //             position: "top-right",
        //             queue: true
        //         });
        //         return;
        //     }

        //     let minimum_quantity;
        //     if (this.decoration_type == 1) {
        //         minimum_quantity =
        //             this.decoration_price_template_values[0].quantity;
        //     } else if (this.decoration_type == 2) {
        //         minimum_quantity =
        //             this.decoration_price_template_values[0].quantity1;
        //     }
        //     // let color_names = [];
        //     let color_names = [];
        //     let is_color_quantity_empty = false;
        //     let gender_total_quantity = 0;
        //     this.gender_groups.forEach((gender) => {
        //         gender.selected_colors.forEach((color) => {
        //             if (!color.total_qty_gender_wise) {
        //                 color_names.push(color.color_name);
        //                 is_color_quantity_empty = true;
        //             }
        //         });
        //         gender_total_quantity += gender.total_qty_gender_wise;
        //     });

        //     if (is_color_quantity_empty) {
        //         this.$toast.error(
        //             `${color_names.join(
        //                 ","
        //             )}  atleast one single quantity is required`,
        //             { position: "top-right", queue: true }
        //         );
        //         return;
        //     }

        //     if (
        //         gender_total_quantity + this.current_cart_quantity <
        //         minimum_quantity
        //     ) {
        //         this.$toast.error(
        //             `Quantity should be greater than or equal to ${minimum_quantity}`,
        //             { position: "top-right", queue: true }
        //         );
        //         return;
        //     }
        //     _this.addIncart();
        // },

        // This function not using
        // addIncart() {
        //     var _this = this;
        //     let selectedProductQty = [];
        //     let allitems = [];

        //     if (_this.gender_groups) {
        //         selectedProductQty = _this.gender_groups.filter(
        //             (element) => element.total_qty_gender_wise > 0
        //         );
        //     }

        //     if (selectedProductQty) {
        //         selectedProductQty.forEach((element) => {
        //             element["selected_colors"].forEach((color) => {
        //                 let items = [];
        //                 color["unique_sizes"].forEach((size) => {
        //                     items.push({
        //                         sub_product_id: size.id,
        //                         user_id: _this.currentUserClient.id,
        //                         case_price: size.price_base,
        //                         markup_price: size.markup_price,
        //                         markup_percentage:
        //                             _this.product.price_markup_percentage,
        //                         ink_price: size.ink_price || 0,
        //                         single_location_price:
        //                             size.single_location_price || 0,
        //                         quantity: size.quantity || 0,
        //                         discount: size.discount ? size.discount : 0.0,
        //                         unit_price: size.cost || 0,
        //                         total_price: size.total_cost || 0
        //                     });
        //                     // }
        //                 });

        //                 allitems.push({
        //                     user_id: _this.currentUserClient.id,
        //                     item_id: _this.product.id,
        //                     gender_size_id: element.id,
        //                     color_id: color.id,
        //                     product_image: color.product_image,
        //                     decoration_type: _this.product.decoration_type,
        //                     price_decoration_bulk:
        //                         _this.product.price_decoration_bulk,
        //                     more_decorations: _this.product.more_decoration,
        //                     items: items,
        //                     imprint_locations: color.imprint_locations,
        //                     total_design_fee: color.total_design_fee,
        //                     total_dark_category_fee:
        //                         color.total_dark_category_fee,
        //                     total_light_category_fee:
        //                         color.total_light_category_fee,
        //                     total_quantity: color.total_qty_gender_wise,
        //                     total_price: color.total_cost_gender_wise,
        //                     setup_fee: color.setup_fee ? color.setup_fee : 0.0,
        //                     imprint_locations_price: color.total_color_fee,
        //                     subtotal_price: color.total_cost_gender_wise,
        //                     artwork: _this.product_artwork
        //                 });
        //             });
        //         });
        //     }
        //     if (_this.currentUserClient.id) {
        //         _this.isBusy = true;
        //         new Promise(() => {
        //             ApiService.post("/add-to-cart", allitems)
        //                 .then(async ({ data }) => {
        //                     if (!data.success) {
        //                         _this.$toast.error(data.error, {
        //                             position: "top-right",
        //                             queue: true
        //                         });
        //                         _this.isBusy = false;
        //                         return;
        //                     }
        //                     await _this.updateCartItems();
        //                     _this.$toast.success(
        //                         "Product has been added into the cart successfully.",
        //                         { position: "top-right", queue: true }
        //                     );
        //                     _this.$root.$emit("update-cart", {
        //                         type: "success"
        //                     });
        //                     /* eslint-disable */
        //                     $("#add-art-work").modal("hide");
        //                     /* eslint-enable */
        //                     _this.resetValues();
        //                     _this.getCartItems();

        //                     // setTimeout(() => {
        //                     //     let default_selected_color = this.colors.find(color => color.default_selection == 1);
        //                     //     if (default_selected_color) {
        //                     //         document.getElementById(`gender_${this.gender_groups[0].id}_color_${default_selected_color.id}`).click();
        //                     //     }
        //                     // }, 100);
        //                     _this.isBusy = false;
        //                 })
        //                 .catch((err) => {
        //                     console.log(err);
        //                 });
        //         });
        //     } else {
        //         selectedProductQty.filter((element) => {
        //             let items = [];
        //             let total_quantity = 0;
        //             let total_price = 0;
        //             let color_id = "";
        //             element["unique_sizes"].forEach((elem) => {
        //                 if (elem.quantity > 0) {
        //                     total_quantity =
        //                         total_quantity + parseInt(elem.quantity);
        //                     total_price =
        //                         total_price + parseFloat(elem.total_cost);
        //                     color_id = elem.color_id;
        //                     items.push({
        //                         sub_product_id: elem.id,
        //                         user_id: _this.currentUserClient.id,
        //                         quantity: elem.quantity,
        //                         unit_price: elem.cost,
        //                         total_price: elem.total_cost,
        //                         sub_prodcut: elem
        //                     });
        //                 }
        //             });
        //             allitems.push({
        //                 user_id: _this.currentUserClient.id,
        //                 item_id: _this.product.id,
        //                 gender_size_id: element.id,
        //                 color_id: color_id,
        //                 imprint_locations: _this.imprint_locations,
        //                 total_quantity: total_quantity,
        //                 total_price: total_price,
        //                 artwork: _this.product_artwork,
        //                 product: _this.product,
        //                 Genderagesize: element,
        //                 CartChildItems: items
        //             });
        //         });
        //         localStorage.setItem("cart", JSON.stringify(allitems));
        //         console.log("completed storing in the local database");
        //         _this.$toast.success(
        //             "Product has been added into the cart successfully.",
        //             { position: "top-right" }
        //         );
        //         _this.$root.$emit("update-cart", { type: "success" });
        //         _this.resetValues();
        //         _this.isBusy = false;
        //     }
        // },

        // This function not using
        // updateCartItems() {
        //     let params = [];
        //     this.same_artwork_cart_items.forEach((item) => {
        //         let child_items = [];
        //         item.CartChildItems.forEach((childItem) => {
        //             child_items.push({
        //                 id: childItem.id,
        //                 sub_product_id: childItem.sub_product_id,
        //                 case_price: childItem.case_price,
        //                 markup_price: childItem.markup_price,
        //                 markup_percentage: childItem.markup_percentage,
        //                 ink_price: childItem.ink_price,
        //                 single_location_price: childItem.single_location_price,
        //                 quantity: childItem.quantity || 0,
        //                 discount: childItem.discount || 0,
        //                 unit_price: childItem.unit_price || 0,
        //                 total_price: childItem.total_price || 0
        //             });
        //         });
        //         params.push({
        //             cart_id: item.id,
        //             child_items: child_items,
        //             total_dark_category_fee: item.total_dark_category_fee,
        //             total_light_category_fee: item.total_light_category_fee,
        //             name_number_fees: item.name_number_fees,
        //             non_standard_fees: item.non_standard_fees,
        //             imprint_locations_price: item.imprint_locations_price,
        //             imprint_locations: item.imprint_locations,
        //             total_quantity: item.total_quantity,
        //             subtotal_price: item.subtotal_price,
        //             total_price: item.total_price
        //         });
        //     });

        //     return new Promise((resolve, reject) => {
        //         ApiService.post("/update-cart", params)
        //             .then(({ data }) => {
        //                 if (!data.success) {
        //                     this.$toast.error(data.error, {
        //                         position: "top-right",
        //                         queue: true
        //                     });
        //                     reject(data);
        //                 }
        //                 resolve(data);
        //             })
        //             .catch((err) => {
        //                 reject(err);
        //             });
        //     });
        // },

        openStartDesignModal() {
            let minimum_quantity;

            let total_qty = 0;
            let error = false;
            let color_names = [];
            this.gender_groups.forEach((gender) => {
                if (gender.selected_colors) {
                    gender.selected_colors.forEach((color) => {
                        if (!color.total_qty_gender_wise) {
                            color_names.push(color.color_name);
                            error = true;
                        }
                    });
                }

                total_qty = total_qty + gender.total_qty_gender_wise;
            });

            if (this.decoration_type == 1) {
                minimum_quantity =
                    this.decoration_price_template_values[0].quantity;
            } else if (this.decoration_type == 2) {
                minimum_quantity =
                    this.decoration_price_template_values[0].quantity1;
            }

            if (error) {
                this.$toast.error(
                    `${color_names.join(
                        ","
                    )} atleast one single quantity is required`,
                    { position: "top-right", queue: true }
                );
                return;
            }

            if (total_qty == 0) {
                this.$toast.error(
                    "Please select color and quantity to design",
                    { position: "top-right", queue: true }
                );
                return;
            } else if (parseInt(total_qty) < parseInt(minimum_quantity)) {
                this.$toast.error(
                    "Quantity should be greater than or equal to " +
                        minimum_quantity,
                    { position: "top-right", queue: true }
                );
                return;
            }

            let is_locations_selected = false;
            let is_area_colors_empty = false;
            for (let location of this.imprint_locations) {
                if (location.is_selected) {
                    is_locations_selected = true;
                    // Check if full color is selected - if yes, skip color validation
                    const isFullColor =
                        location.is_full_color_selected === true ||
                        location.no_of_color === "full_color";
                    if (!isFullColor && location.colors.length == 0) {
                        is_area_colors_empty = true;
                        break;
                    }
                }
            }

            let errorText = "";
            if (this.product.decoration_type == 1) {
                errorText = "imprint locations";
            } else if (this.product.decoration_type == 2) {
                errorText = "embroidery locations";
            }

            if (!is_locations_selected) {
                this.$toast.error(`Please select ${errorText}.`, {
                    position: "top-right",
                    queue: true
                });
                return;
            } else if (is_area_colors_empty) {
                this.$toast.error(
                    `Please select colors for selected ${errorText}.`,
                    { position: "top-right", queue: true }
                );
                return;
            }
            /* eslint-disable */
            $("#add-art-work").modal("show");
            /* eslint-enable */
        },

        async startDesign() {
            var _this = this;
            let cart = [];
            /* eslint-disable */
            $("#add-art-work").modal("hide");
            /* eslint-enable */

            // Minimum quantity check
            let total_qty = 0;
            this.gender_groups.forEach((gender) => {
                total_qty += gender.total_qty_gender_wise;
            });

            let minimum_quantity = 0;
            const activeService = this.activeDecorationService;
            if (!activeService) {
                this.$toast.error("Please select a decoration service.", {
                    position: "top-right"
                });
                return;
            }

            // Determine minimum quantity based on the active service
            if (
                activeService.price_decoration_bulk &&
                activeService.price_decoration_bulk.length > 0
            ) {
                if (activeService.use_imprintcity_price_template === 0) {
                    // New PCNA pricing structure
                    minimum_quantity =
                        activeService.price_decoration_bulk[0].quantity;
                } else {
                    // Old Imprint City template pricing structure
                    if (
                        this.decoration_type == 1 &&
                        this.decoration_price_template_values &&
                        this.decoration_price_template_values.length > 0
                    ) {
                        minimum_quantity =
                            this.decoration_price_template_values[0].quantity;
                    } else if (
                        this.decoration_type == 2 &&
                        this.decoration_price_template_values &&
                        this.decoration_price_template_values.length > 0
                    ) {
                        minimum_quantity =
                            this.decoration_price_template_values[0].quantity1;
                    }
                }
            }

            if (total_qty < minimum_quantity) {
                this.$toast.error(
                    "Quantity should be greater than or equal to " +
                        minimum_quantity,
                    { position: "top-right", queue: true }
                );
                return;
            }

            let productForDesignStudio = JSON.parse(
                JSON.stringify(_this.product)
            );

            // Update the 'is_default' flag in the decorations array based on the activeService
            try {
                let decorationsData = JSON.parse(
                    productForDesignStudio.decorations
                );
                if (
                    decorationsData &&
                    decorationsData[0] &&
                    decorationsData[0].decoration_type_list
                ) {
                    decorationsData[0].decoration_type_list.forEach(
                        (service) => {
                            // Set is_default based on whether the service ID matches the active service ID
                            service.is_default =
                                service.id === activeService.id;
                        }
                    );
                    productForDesignStudio.decorations =
                        JSON.stringify(decorationsData);
                }
            } catch (e) {
                console.error("Could not update default decoration:", e);
            }

            // Update decoration_type based on active service
            productForDesignStudio.decoration_type =
                activeService.decoration_type;

            if (activeService.use_imprintcity_price_template === 1) {
                // If using Imprint City template pricing
                productForDesignStudio.decoration_price_template =
                    activeService.decoration_price_template; // Set the correct template ID from active service

                // Also update PrintTemplate/Embroidery objects based on the type
                if (activeService.decoration_type === 1) {
                    const template = this.printTemplates.find(
                        (t) => t.id === activeService.decoration_price_template
                    );
                    productForDesignStudio.PrintTemplate = template || null;
                    productForDesignStudio.Embroidery = null; // Ensure Embroidery is null
                } else if (activeService.decoration_type === 2) {
                    const template = this.embroideryTemplates.find(
                        (t) => t.id === activeService.decoration_price_template
                    );
                    productForDesignStudio.Embroidery = template || null;
                    // Optionally update PrintTemplate object to reflect Embroidery details if needed, or set to null
                    if (template) {
                        productForDesignStudio.PrintTemplate = null;
                    } else {
                        productForDesignStudio.PrintTemplate = null;
                    }
                } else {
                    // Handle other decoration types if necessary, otherwise clear templates
                    productForDesignStudio.PrintTemplate = null;
                    productForDesignStudio.Embroidery = null;
                }
            } else {
                // If using PCNA pricing (flag is 0)
                productForDesignStudio.decoration_price_template = null; // Set template ID to null
                productForDesignStudio.PrintTemplate = null; // Clear related templates
                productForDesignStudio.Embroidery = null;
            }

            // Ensure Vendor.newVendorColors exists (it might be set earlier)
            if (
                productForDesignStudio.Vendor &&
                !productForDesignStudio.Vendor.VendorColors
            ) {
                productForDesignStudio.Vendor.VendorColors =
                    _this.imprint_colors_array_for_template || [];
            }

            // Loop through gender groups to prepare the 'cart' array
            this.gender_groups.forEach((gender) => {
                if (gender.total_qty_gender_wise > 0) {
                    const colorsForDesignStudio = gender.selected_colors
                        .filter((color) =>
                            // Only include colors where at least one size has quantity > 0
                            color.unique_sizes.some((size) => size.quantity > 0)
                        )
                        .map((color) => {
                            // Create a deep copy of the color object to avoid modifying the original
                            let newColorObject = JSON.parse(
                                JSON.stringify(color)
                            );
                            // Attach the current imprint locations state to this color object
                            newColorObject.imprint_locations = JSON.parse(
                                JSON.stringify(_this.imprint_locations)
                            );
                            return newColorObject;
                        });

                    // Only add to cart if there are actually selected colors with quantities
                    if (colorsForDesignStudio.length > 0) {
                        cart.push({
                            item: productForDesignStudio, // Use the MODIFIED product object
                            color: colorsForDesignStudio[0], // Keep the first selected color reference if needed
                            colors: colorsForDesignStudio, // Array of selected colors with quantities and imprint locations
                            gender_name: gender.gender,
                            gender_id: gender.id,
                            base_price: _this.product.price_base, // Base price might need re-evaluation based on logic
                            total_qty: gender.total_qty_gender_wise,
                            subtotal: gender.subtotal,
                            total_color_fee: gender.total_color_fee || 0,
                            total_cost: gender.total_cost_gender_wise,
                            total_design_fee: gender.total_design_fee,
                            total_discount_value: gender.total_discount_value,
                            total_setup_fee: _this.setup_fee, // Ensure setup_fee is correctly calculated and available
                            imprint_locations: _this.imprint_locations, // Main imprint locations state
                            artwork: _this.product_artwork,
                            markup_percentage:
                                _this.product.price_markup_percentage,
                            activeServiceData: (() => {
                                // Create a deep copy of activeDecorationService
                                const activeServiceData = JSON.parse(
                                    JSON.stringify(this.activeDecorationService)
                                );

                                // Enrich other_services_list with full data from VendorOtherServices
                                if (
                                    activeServiceData &&
                                    activeServiceData.other_services_list &&
                                    Array.isArray(
                                        activeServiceData.other_services_list
                                    )
                                ) {
                                    const vendorOtherServices =
                                        _this.product.VendorOtherServices || [];

                                    activeServiceData.other_services_list =
                                        activeServiceData.other_services_list.map(
                                            (service) => {
                                                // Find full service data from VendorOtherServices
                                                const fullServiceData =
                                                    vendorOtherServices.find(
                                                        (vs) =>
                                                            vs.id === service.id
                                                    );

                                                return {
                                                    id: service.id,
                                                    name:
                                                        (fullServiceData &&
                                                            fullServiceData.name) ||
                                                        (fullServiceData &&
                                                            fullServiceData.master_service &&
                                                            fullServiceData
                                                                .master_service
                                                                .service_name) ||
                                                        service.name ||
                                                        "",
                                                    ecomm_display:
                                                        (fullServiceData &&
                                                            fullServiceData.ecomm_display) ||
                                                        (fullServiceData &&
                                                            fullServiceData.master_service &&
                                                            fullServiceData
                                                                .master_service
                                                                .ecomm_display) ||
                                                        service.ecomm_display ||
                                                        "",
                                                    fee_structure:
                                                        (fullServiceData &&
                                                            fullServiceData.fee_structure) ||
                                                        (fullServiceData &&
                                                            fullServiceData.rollup_service &&
                                                            fullServiceData
                                                                .rollup_service
                                                                .fee_structure_name) ||
                                                        service.fee_structure ||
                                                        "",
                                                    retail_cost:
                                                        service.retail_cost ||
                                                        (fullServiceData &&
                                                            fullServiceData.retail_cost) ||
                                                        0,
                                                    net_cost:
                                                        service.net_cost ||
                                                        (fullServiceData &&
                                                            fullServiceData.net_cost) ||
                                                        0,
                                                    show_service: (() => {
                                                        const showService =
                                                            fullServiceData &&
                                                            fullServiceData.show_service !==
                                                                undefined
                                                                ? fullServiceData.show_service
                                                                : service.show_service !==
                                                                  undefined
                                                                ? service.show_service
                                                                : false;
                                                        // Keep boolean as is (true/false), convert 0/1 to boolean
                                                        if (
                                                            typeof showService ===
                                                            "boolean"
                                                        ) {
                                                            return showService;
                                                        }
                                                        // Convert 0/1 to boolean
                                                        if (
                                                            showService === 0 ||
                                                            showService === "0"
                                                        ) {
                                                            return false;
                                                        }
                                                        if (
                                                            showService === 1 ||
                                                            showService === "1"
                                                        ) {
                                                            return true;
                                                        }
                                                        // Default to false
                                                        return false;
                                                    })(),
                                                    rollup_fee_id:
                                                        (fullServiceData &&
                                                            fullServiceData.rollup_fee_id) ||
                                                        service.rollup_fee_id ||
                                                        null,
                                                    rollup_fee_name:
                                                        (fullServiceData &&
                                                            fullServiceData.rollup_fee_name) ||
                                                        service.rollup_fee_name ||
                                                        null
                                                };
                                            }
                                        );
                                }

                                // Add Color Mix Fee value from VendorFees (only the relevant one)
                                if (activeServiceData) {
                                    const vendorFees =
                                        _this.product &&
                                        _this.product.VendorFees
                                            ? _this.product.VendorFees
                                            : [];
                                    const decorationType =
                                        activeServiceData.decoration_type;
                                    const serviceName =
                                        activeServiceData.master_service &&
                                        activeServiceData.master_service
                                            .service_name
                                            ? activeServiceData.master_service
                                                  .service_name
                                            : "";

                                    // Determine if it's embroidery or ink based on decoration type and service name
                                    let targetService = null;

                                    if (decorationType == 2) {
                                        // Decoration type 2 = Embroidery = Thread Mix Fee
                                        targetService = vendorFees.find(
                                            (service) =>
                                                service.type === "thread_fee" ||
                                                (service.ecomm_display &&
                                                    service.ecomm_display
                                                        .toLowerCase()
                                                        .includes(
                                                            "thread mix fee"
                                                        ))
                                        );
                                    } else if (decorationType == 1) {
                                        // Decoration type 1 = Screen Print = Ink Mix Fee
                                        targetService = vendorFees.find(
                                            (service) =>
                                                service.type ===
                                                    "custom_ink_mix" ||
                                                (service.ecomm_display &&
                                                    service.ecomm_display
                                                        .toLowerCase()
                                                        .includes(
                                                            "ink mix fee"
                                                        ))
                                        );
                                    } else if (decorationType == 0) {
                                        // Decoration type 0 = PCNA - check service name
                                        const serviceNameLower = serviceName
                                            ? serviceName.toLowerCase()
                                            : "";
                                        const isEmbroidery =
                                            serviceNameLower.includes(
                                                "embroidery"
                                            );
                                        const isPrint =
                                            serviceNameLower.includes("print");

                                        if (isEmbroidery) {
                                            // Embroidery service = Thread Mix Fee
                                            targetService = vendorFees.find(
                                                (service) =>
                                                    service.type ===
                                                        "thread_fee" ||
                                                    (service.ecomm_display &&
                                                        service.ecomm_display
                                                            .toLowerCase()
                                                            .includes(
                                                                "thread mix fee"
                                                            ))
                                            );
                                        } else if (isPrint) {
                                            // Print service = Ink Mix Fee
                                            targetService = vendorFees.find(
                                                (service) =>
                                                    service.type ===
                                                        "custom_ink_mix" ||
                                                    (service.ecomm_display &&
                                                        service.ecomm_display
                                                            .toLowerCase()
                                                            .includes(
                                                                "ink mix fee"
                                                            ))
                                            );
                                        }
                                        // If neither embroidery nor print, targetService remains null (no fee)
                                    }

                                    if (
                                        targetService &&
                                        targetService.retail_cost
                                    ) {
                                        activeServiceData.color_mix_fee =
                                            parseFloat(
                                                targetService.retail_cost
                                            ) || 0;
                                    }
                                }

                                return activeServiceData;
                            })()
                        });
                    }
                }
            });

            if (cart.length > 0) {
                localStorage.setItem("design", JSON.stringify(cart));
                localStorage.setItem("is24Tshirt", this.is_tshirt_24_hour);
                localStorage.setItem("colorIndex", 0); // Reset color index for Design Studio

                // Find the currently active service again to pass the pricing flag
                const currentActiveService = this.decoration_services.find(
                    (service) => service.isActive === true
                );
                const pricingFlag =
                    currentActiveService &&
                    currentActiveService.use_imprintcity_price_template !==
                        undefined
                        ? currentActiveService.use_imprintcity_price_template
                        : 1; // Default to 1 if not found

                let hashValue = "";
                if (this.start_designing_with == "existing") {
                    hashValue = "#designs";
                } else if (this.start_designing_with == "upload") {
                    hashValue = "#upload";
                }

                // Navigate to Design Studio with the pricing flag in the query
                this.$router.push({
                    name: "DesignStudioV3",
                    query: { pricingFlag: pricingFlag }, // Pass the flag
                    hash: hashValue
                });
            } else {
                // Handle the case where no items have quantity selected
                this.$toast.error(
                    "Please select quantity for at least one item.",
                    {
                        position: "top-right",
                        queue: true
                    }
                );
            }
        },

        // This function not using
        resetAllImprintLocationsData() {
            this.imprint_locations.forEach((locations) => {
                locations.colors = [];
                locations.is_selected = false;
                locations.price = 0;
                locations.total_price = 0;
                locations.no_of_color = null;
            });
        },

        selectImprintLocations(index) {
            if (this.imprint_locations[index].is_selected) {
                this.imprint_locations[index].no_of_color = null;
                this.imprint_locations[index].colors = [];
            }
            this.imprint_locations[index].is_selected =
                !this.imprint_locations[index].is_selected;
            this.calculatePricing(this.is_active);
            this.$forceUpdate();
        },

        selectNumberOfColors(location, count) {
            // Handle "Full color" selection
            if (count === "full_color" || count === "Full color") {
                location.no_of_color = "full_color";
                location.is_full_color = true;
                location.colors = []; // No individual color selection for full color
            } else {
                let no_of_colors = parseInt(count) || 0;
                location.no_of_color = parseInt(count) || null;
                location.is_full_color = false;
                location.colors = [];
                for (let i = 0; i < no_of_colors; i++) {
                    location.colors.push({
                        color: null,
                        color_cost: 0.0,
                        cost_cost: 0.0,
                        cost_sum_added: false
                    });
                }
            }
            this.calculatePricing(this.is_active);
        },

        calcImprintLocationByGender(genderIndex) {
            const activeService = this.activeDecorationService;
            if (!activeService) return 0;

            let gender_element = this.gender_groups[genderIndex];
            if (!gender_element) return 0;

            let totalCalculatedDecorationFee = 0;
            let initalLocationIndex = 0;
            const total_gender_quantity =
                this.getTotalItemQuantity(gender_element);
            this.total_decoration_colors_count = 0;

            if (activeService.use_imprintcity_price_template === 0) {
                if (!activeService.master_service) {
                    return 0;
                }
                const pricing = activeService.master_service;

                this.imprint_locations.forEach((location) => {
                    location.decoration_fee = 0;
                    if (location.is_selected) {
                        // Check if "Full color" is selected
                        if (
                            location.no_of_color === "full_color" ||
                            location.is_full_color === true
                        ) {
                            // Use full_color value from VendorDecorationService for run charge
                            const fullColorValue = parseFloat(
                                pricing.full_color || 0
                            );
                            let calculatedFeePerItem = 0;
                            if (initalLocationIndex === 0) {
                                calculatedFeePerItem =
                                    fullColorValue +
                                    parseFloat(pricing.location_1st || 0);
                            } else {
                                calculatedFeePerItem =
                                    fullColorValue +
                                    parseFloat(
                                        pricing.additional_location || 0
                                    );
                            }
                            location.decoration_fee = calculatedFeePerItem;
                            location.is_full_color_selected = true;
                            location.full_color_value = fullColorValue;

                            if (total_gender_quantity > 0) {
                                totalCalculatedDecorationFee +=
                                    calculatedFeePerItem *
                                    total_gender_quantity;
                            }
                            this.total_decoration_colors_count += 1; // Count as 1 for full color
                        } else {
                            const color_count =
                                parseInt(location.no_of_color) || 0;
                            this.total_decoration_colors_count += color_count;
                            if (color_count > 0) {
                                let calculatedFeePerItem = 0;
                                if (initalLocationIndex === 0) {
                                    calculatedFeePerItem =
                                        color_count *
                                            parseFloat(
                                                pricing.cost_per_color_1st
                                            ) +
                                        parseFloat(pricing.location_1st);
                                } else {
                                    calculatedFeePerItem =
                                        color_count *
                                            parseFloat(
                                                pricing.cost_per_color_2ndormore
                                            ) +
                                        parseFloat(pricing.additional_location);
                                }
                                location.decoration_fee = calculatedFeePerItem;
                                location.is_full_color_selected = false;

                                if (total_gender_quantity > 0) {
                                    totalCalculatedDecorationFee +=
                                        calculatedFeePerItem *
                                        total_gender_quantity;
                                }
                            }
                        }
                        initalLocationIndex++;
                    }
                });
            } else if (activeService.use_imprintcity_price_template === 1) {
                if (this.product.decoration_type == 1) {
                    // Old Print Logic
                    this.imprint_locations.forEach((location) => {
                        if (location.is_selected) {
                            // Check if "Full color" is selected
                            if (
                                location.no_of_color === "full_color" ||
                                location.is_full_color === true
                            ) {
                                // Use full_color value from decoration service JSON for run charge
                                const fullColorValue = parseFloat(
                                    activeService.full_color || 0
                                );
                                let calculatedFeePerItem = 0;

                                // For ImprintCity, we still need to handle location fees
                                if (initalLocationIndex == 0) {
                                    // First location - full color value only (no location fee for first location in old logic)
                                    calculatedFeePerItem = fullColorValue;
                                } else {
                                    // Additional locations - need to get location fee from template
                                    const additionalLocationPrice =
                                        this.getDecorationPrice(
                                            0,
                                            undefined,
                                            true // is additional location
                                        );
                                    calculatedFeePerItem =
                                        fullColorValue +
                                        parseFloat(
                                            additionalLocationPrice || 0
                                        );
                                }

                                location.decoration_fee = calculatedFeePerItem;
                                location.total_decoration_fee =
                                    parseFloat(location.decoration_fee) *
                                    total_gender_quantity;
                                location.is_full_color_selected = true;
                                location.full_color_value = fullColorValue;
                                totalCalculatedDecorationFee +=
                                    location.total_decoration_fee;
                                this.total_decoration_colors_count += 1; // Count as 1 for full color
                            } else {
                                const no_of_colors =
                                    parseInt(location.no_of_color) || 0;
                                if (
                                    initalLocationIndex == 0 &&
                                    no_of_colors == 1
                                ) {
                                    location.decoration_fee = 0;
                                    location.total_decoration_fee = 0;
                                } else if (no_of_colors > 0) {
                                    const decoration_price =
                                        this.getDecorationPrice(
                                            no_of_colors - 1,
                                            undefined,
                                            initalLocationIndex > 0
                                        );
                                    const color1_decoration_price =
                                        this.getDecorationPrice(
                                            0,
                                            undefined,
                                            initalLocationIndex > 0
                                        );
                                    location.decoration_fee =
                                        parseFloat(decoration_price);
                                    if (initalLocationIndex == 0) {
                                        location.decoration_fee -= parseFloat(
                                            color1_decoration_price
                                        );
                                    }
                                    location.total_decoration_fee =
                                        parseFloat(location.decoration_fee) *
                                        total_gender_quantity;
                                    totalCalculatedDecorationFee +=
                                        location.total_decoration_fee;
                                }
                                location.is_full_color_selected = false;
                                this.total_decoration_colors_count +=
                                    no_of_colors;
                            }
                            initalLocationIndex++;
                        }
                    });
                } else if (this.product.decoration_type == 2) {
                    // Old Embroidery Logic
                    this.imprint_locations.forEach((location) => {
                        if (location.is_selected) {
                            // Check if "Full color" is selected
                            if (
                                location.no_of_color === "full_color" ||
                                location.is_full_color === true
                            ) {
                                // Use full_color value from decoration service JSON for run charge
                                const fullColorValue = parseFloat(
                                    activeService.full_color || 0
                                );
                                let calculatedFeePerItem = 0;

                                if (initalLocationIndex == 0) {
                                    // First location - full color value only (no location fee for first location in old logic)
                                    calculatedFeePerItem = fullColorValue;
                                } else {
                                    // Additional locations - need to get location fee from template
                                    let decoration_price =
                                        this.getDecorationPrice(
                                            0,
                                            initalLocationIndex
                                        );
                                    calculatedFeePerItem =
                                        fullColorValue +
                                        parseFloat(decoration_price || 0);
                                }

                                location.decoration_fee = calculatedFeePerItem;
                                location.total_decoration_fee =
                                    parseFloat(location.decoration_fee) *
                                    total_gender_quantity;
                                location.is_full_color_selected = true;
                                location.full_color_value = fullColorValue;
                                totalCalculatedDecorationFee +=
                                    location.total_decoration_fee;
                                this.total_decoration_colors_count += 1; // Count as 1 for full color
                            } else {
                                if (initalLocationIndex == 0) {
                                    location.decoration_fee = 0;
                                    location.total_decoration_fee = 0;
                                } else {
                                    // This handles ALL additional locations (2nd, 3rd, etc.)
                                    let decoration_price =
                                        this.getDecorationPrice(
                                            0,
                                            initalLocationIndex
                                        );
                                    location.decoration_fee =
                                        parseFloat(decoration_price);
                                    location.total_decoration_fee =
                                        parseFloat(location.decoration_fee) *
                                        total_gender_quantity;
                                    totalCalculatedDecorationFee +=
                                        location.total_decoration_fee;
                                }
                                location.is_full_color_selected = false;
                                // This is not used for embroidery pricing but we keep it for consistency if needed elsewhere.
                                let no_of_colors =
                                    parseInt(location.no_of_color) || 0;
                                this.total_decoration_colors_count +=
                                    no_of_colors;
                            }
                            initalLocationIndex++;
                        }
                    });
                }
            }

            return totalCalculatedDecorationFee;
        },

        getTotalItemQuantity(gender_element) {
            if (!gender_element || !gender_element.selected_colors) {
                return 0;
            }
            let total_quantity = 0;
            gender_element.selected_colors.forEach((color) => {
                color.unique_sizes.forEach((size) => {
                    if (size.quantity > 0) {
                        total_quantity += parseInt(size.quantity);
                    }
                });
            });
            return total_quantity;
        },

        getRetailPrice(prices) {
            let item_price = 0;
            if (prices.base_price) {
                item_price += parseFloat(prices.base_price);
            }

            if (prices.markup_price) {
                item_price += parseFloat(prices.markup_price);
            }

            if (prices.single_location_price) {
                item_price += parseFloat(prices.single_location_price);
            }

            if (prices.color_category_price) {
                item_price += parseFloat(prices.color_category_price);
            }

            if (prices.decoration_discount_percentage) {
                let decoration_discount_value =
                    (this.icPriceFormat(item_price, true) *
                        parseFloat(prices.decoration_discount_percentage)) /
                    100;
                item_price -= parseFloat(decoration_discount_value);
            }

            return item_price;
        },

        calculatePricing(index, size, event = null) {
            var _this = this;
            if (event && event.target.value > _this.max_cart_count) {
                let error_message =
                    "Quantity should not be greater than " +
                    _this.max_cart_count;
                _this.$toast.error(error_message, {
                    position: "top-right",
                    queue: true
                });
                event.target.value = 0;
                size.quantity = null; // v-model ki value ko reset karein
            }
            const activeService = this.activeDecorationService;
            if (!activeService) {
                return;
            }

            const flag = activeService.use_imprintcity_price_template;
            const current_decoration_type = activeService.decoration_type;

            if (flag === 0) {
                this.calculateNewTierPricing(index);
            } else {
                if (current_decoration_type == 1) {
                    this.calculateOldPrintPricing(index);
                } else if (current_decoration_type == 2) {
                    this.calculateOldEmbroideryPricing(index);
                }
            }
            let total_qty = 0;
            this.gender_groups.forEach((gender) => {
                total_qty += gender.total_qty_gender_wise;
            });
            this.disable_btns = total_qty === 0;
        },

        calculateNewTierPricing(index) {
            let gender_element = this.gender_groups[index];
            if (
                !gender_element ||
                !Array.isArray(gender_element["selected_colors"])
            ) {
                return;
            }
            // Reset all relevant values before recalculating
            gender_element.total_qty_gender_wise = 0;
            gender_element.subtotal = 0; // This will hold the undiscounted base cost of all items.
            gender_element.total_cost_gender_wise = 0;
            gender_element.total_discount_value = 0; // This will store the final calculated discount amount.
            gender_element.total_design_fee = 0;
            gender_element.total_color_fee = 0;

            const activeService = this.activeDecorationService;
            const priceData = activeService.price_decoration_bulk;
            let total_group_quantity =
                this.getTotalItemQuantity(gender_element);
            let found_tier = null;

            // Find the correct pricing tier based on the total quantity.
            if (priceData && priceData.length > 0) {
                found_tier = priceData[0]; // Default to the first tier.
                for (const tier of priceData) {
                    if (tier.quantity <= total_group_quantity) {
                        found_tier = tier;
                    } else {
                        break;
                    }
                }
            }

            let tier_retail_cost = found_tier
                ? parseFloat(found_tier.retail_cost || 0)
                : 0;

            //Calculate subtotal (base cost) for all items WITHOUT applying any discounts
            gender_element["selected_colors"].forEach((color) => {
                // Reset color-specific values
                color.total_qty_gender_wise = 0;
                color.subtotal = 0;
                color.total_cost_gender_wise = 0;
                color.total_discount_value = 0;
                color.total_design_fee = 0;

                if (color.total_qty_gender_wise > 0) {
                    color.total_design_fee = this.design_fee;
                }

                color["unique_sizes"].forEach((size) => {
                    size.cost = tier_retail_cost;
                    size.discount = 0;

                    let color_category_price = this.getDarkLightFees(color);
                    let cost_per_item_with_fee =
                        size.cost + color_category_price;

                    size.total_cost =
                        size.quantity > 0
                            ? cost_per_item_with_fee * parseInt(size.quantity)
                            : 0;

                    if (size.quantity > 0) {
                        color.total_qty_gender_wise += parseInt(size.quantity);
                        color.subtotal += size.total_cost;
                    }
                });

                color.total_cost_gender_wise =
                    color.subtotal + color.total_design_fee;

                // Aggregate values up to the gender level.
                gender_element.total_qty_gender_wise +=
                    color.total_qty_gender_wise;
                gender_element.subtotal += color.subtotal; // `subtotal` is now the sum of all UNDISCOUNTED item prices.
                gender_element.total_design_fee += color.total_design_fee;
            });

            // Calculate all other fees and the total before discount
            const totalDecorationFee = this.calcImprintLocationByGender(index);
            gender_element.total_color_fee = totalDecorationFee;

            this.setup_fee = this.calculateSetupFee(
                activeService,
                gender_element.total_qty_gender_wise,
                this.total_decoration_colors_count
            );

            const otherServicesTotal = this.otherServices.reduce(
                (total, service) => {
                    const cost = parseFloat(service.retail_cost) || 0;
                    if (service.fee_structure === "Per Item") {
                        // Multiply by quantity if it's 'Per Item'
                        return total + cost * total_group_quantity;
                    } else {
                        // Otherwise, just add the flat fee
                        return total + cost;
                    }
                },
                0
            );

            // This is the grand total of all charges BEFORE the promotional discount.
            const preDiscountTotal =
                gender_element.subtotal +
                gender_element.total_design_fee +
                totalDecorationFee +
                this.setup_fee +
                otherServicesTotal;

            // Calculate the promotional discount on the pre-discount grand total ---
            let mainDiscountAmount = 0;
            const activeDiscount = this.activeProductDiscount; // Use the new computed property
            if (activeDiscount && preDiscountTotal > 0) {
                let discount_type = activeDiscount.discount_type;
                let discount_value = parseFloat(activeDiscount.discount_value);
                if (discount_type == "Percent") {
                    mainDiscountAmount =
                        (preDiscountTotal * discount_value) / 100;
                } else {
                    // For a fixed amount, ensure the discount isn't more than the total itself.
                    mainDiscountAmount = Math.min(
                        preDiscountTotal,
                        discount_value
                    );
                }
            }
            gender_element.total_discount_value = mainDiscountAmount;

            // Calculate the final total cost by subtracting the discount
            const finalTotalCost =
                preDiscountTotal - gender_element.total_discount_value;
            gender_element.total_cost_gender_wise = finalTotalCost;

            // Create run charge details array with full color breakdown
            const runChargeDetails = [];
            if (totalDecorationFee > 0) {
                // Build detailed breakdown by location
                this.imprint_locations.forEach((location, locIndex) => {
                    if (location.is_selected && location.decoration_fee > 0) {
                        if (
                            location.is_full_color_selected &&
                            location.full_color_value
                        ) {
                            // Full color location - don't add to runChargeDetails
                            // Location Fee and Full Color entries removed as per requirement
                        } else {
                            // Regular color location
                            // Location-specific Run Charge entries removed - not showing in breakdown
                            // const locationName =
                            //     locIndex === 0
                            //         ? "Location 1"
                            //         : `Location ${locIndex + 1}`;
                            // runChargeDetails.push({
                            //     name: `${locationName} Run Charge`,
                            //     value: parseFloat(
                            //         location.decoration_fee.toFixed(2)
                            //     ),
                            //     unitPrice: parseFloat(
                            //         location.decoration_fee.toFixed(2)
                            //     ),
                            //     quantity: gender_element.total_qty_gender_wise
                            // });
                        }
                    }
                });

                // If no detailed breakdown, add general location run charge
                // if (runChargeDetails.length === 0) {
                //     runChargeDetails.push({
                //         name: "Location(s) Run Charge",
                //         value: parseFloat(totalDecorationFee.toFixed(2))
                //     });
                // }
            }

            // Populate the `currentBreakdown` object for the display component
            this.currentBreakdown = {
                baseCost: gender_element.subtotal,
                runCharge: totalDecorationFee,
                setupFee: this.setup_fee,
                totalCost: finalTotalCost,
                totalDiscount: gender_element.total_discount_value,
                designFee: gender_element.total_design_fee,
                runChargeDetails: runChargeDetails
            };

            this.$forceUpdate();
        },

        calculateOldPrintPricing(index) {
            const activeService = this.activeDecorationService;
            let gender_element = this.gender_groups[index];
            if (!gender_element) {
                return;
            }
            let total_group_quantity =
                this.getTotalItemQuantity(gender_element);

            // Reset all gender-level totals
            gender_element.total_discount_value = 0;
            gender_element.total_qty_gender_wise = 0;
            gender_element.total_cost_gender_wise = 0;
            gender_element.total_color_fee = 0;
            gender_element.subtotal = 0;
            this.setup_fee = 0;

            if (gender_element["selected_colors"]) {
                // Get the tier-based decoration price and discount ONCE for the current quantity tier.
                let single_location_price = this.getDecorationPrice();
                let decoration_discount_percentage =
                    this.getDecorationDiscount();

                gender_element["selected_colors"].forEach(
                    (selected_color_obj) => {
                        // Reset color-level totals
                        selected_color_obj.total_qty_gender_wise = 0;
                        selected_color_obj.subtotal = 0;
                        selected_color_obj.total_cost_gender_wise = 0;

                        // Loop through each size
                        selected_color_obj["unique_sizes"].forEach((size) => {
                            let base_price =
                                size.price_base || this.product.price_base;

                            const activeService = this.activeDecorationService;
                            let markup_percentage = activeService
                                ? activeService.markup_percentage
                                : this.product.price_markup_percentage;
                            let mark_up_cost =
                                (base_price * markup_percentage) / 100;
                            size.markup_price = mark_up_cost;
                            let color_category_price =
                                this.getDarkLightFees(selected_color_obj);

                            let decoration_discount_amount =
                                (parseFloat(single_location_price) *
                                    parseFloat(
                                        decoration_discount_percentage
                                    )) /
                                100;
                            let discounted_decoration_price =
                                parseFloat(single_location_price) -
                                decoration_discount_amount;

                            size.cost =
                                parseFloat(base_price) +
                                parseFloat(mark_up_cost) +
                                parseFloat(color_category_price) +
                                discounted_decoration_price;

                            size.single_location_price = single_location_price;
                            size.decoration_discount_percentage =
                                decoration_discount_percentage;

                            // Only if there is a quantity, calculate totals
                            if (size.quantity && size.quantity > 0) {
                                size.total_cost =
                                    this.icPriceFormat(size.cost, true) *
                                    parseInt(size.quantity);
                                selected_color_obj.subtotal += parseFloat(
                                    size.total_cost
                                );
                                selected_color_obj.total_cost_gender_wise +=
                                    parseFloat(size.total_cost);
                                selected_color_obj.total_qty_gender_wise +=
                                    parseInt(size.quantity);
                            } else {
                                size.total_cost = 0;
                            }
                        });

                        // Aggregate up to the gender level
                        gender_element.subtotal += parseFloat(
                            selected_color_obj.subtotal
                        );
                        gender_element.total_qty_gender_wise += parseFloat(
                            selected_color_obj.total_qty_gender_wise
                        );
                    }
                );
            }

            const total_decoration_fee =
                this.calcImprintLocationByGender(index);
            this.setup_fee = this.calculateSetupFee(
                activeService,
                gender_element.total_qty_gender_wise,
                this.total_decoration_colors_count
            );
            const otherServicesTotal = this.otherServices.reduce(
                (total, service) => {
                    const cost = parseFloat(service.retail_cost) || 0;
                    if (service.fee_structure === "Per Item") {
                        return total + cost * total_group_quantity;
                    } else {
                        return total + cost;
                    }
                },
                0
            );

            const preDiscountTotal =
                gender_element.subtotal +
                total_decoration_fee +
                this.setup_fee +
                otherServicesTotal;

            let mainDiscountAmount = 0;
            const activeDiscount = this.activeProductDiscount;
            if (activeDiscount && preDiscountTotal > 0) {
                let discount_type = activeDiscount.discount_type;
                let discount_value = parseFloat(activeDiscount.discount_value);
                if (discount_type == "Percent") {
                    mainDiscountAmount =
                        (preDiscountTotal * discount_value) / 100;
                } else {
                    mainDiscountAmount = Math.min(
                        preDiscountTotal,
                        discount_value
                    );
                }
            }
            gender_element.total_discount_value = mainDiscountAmount;

            gender_element.total_color_fee = parseFloat(total_decoration_fee);
            gender_element.total_cost_gender_wise =
                preDiscountTotal - mainDiscountAmount;

            // Create run charge details array with full color breakdown
            const runChargeDetails = [];
            if (gender_element.total_color_fee > 0) {
                // Build detailed breakdown by location
                this.imprint_locations.forEach((location, locIndex) => {
                    if (location.is_selected && location.decoration_fee > 0) {
                        if (
                            location.is_full_color_selected &&
                            location.full_color_value
                        ) {
                            // Full color location
                            const locationName =
                                locIndex === 0
                                    ? "Location 1"
                                    : `Location ${locIndex + 1}`;
                            // Full Color entry removed - not added to runChargeDetails
                            // Add location fee if applicable (for additional locations)
                            if (
                                locIndex > 0 &&
                                location.total_decoration_fee >
                                    location.full_color_value *
                                        gender_element.total_qty_gender_wise
                            ) {
                                const locationFee =
                                    (location.total_decoration_fee -
                                        location.full_color_value *
                                            gender_element.total_qty_gender_wise) /
                                    gender_element.total_qty_gender_wise;
                                if (locationFee > 0) {
                                    // Location Fee entry removed - not added to runChargeDetails
                                }
                            }
                        } else {
                            // Regular color location
                            // Location-specific Run Charge entries removed - not showing in breakdown
                            // const locationName =
                            //     locIndex === 0
                            //         ? "Location 1"
                            //         : `Location ${locIndex + 1}`;
                            // runChargeDetails.push({
                            //     name: `${locationName} Run Charge`,
                            //     value: parseFloat(
                            //         location.decoration_fee.toFixed(2)
                            //     ),
                            //     unitPrice: parseFloat(
                            //         location.decoration_fee.toFixed(2)
                            //     ),
                            //     quantity: gender_element.total_qty_gender_wise
                            // });
                        }
                    }
                });

                // If no detailed breakdown, add general location run charge
                // if (runChargeDetails.length === 0) {
                //     runChargeDetails.push({
                //         name: "Location(s) Run Charge",
                //         value: parseFloat(
                //             gender_element.total_color_fee.toFixed(2)
                //         )
                //     });
                // }
            }

            this.currentBreakdown = {
                baseCost: gender_element.subtotal,
                runCharge: gender_element.total_color_fee,
                setupFee: this.setup_fee,
                totalCost: gender_element.total_cost_gender_wise,
                totalDiscount: gender_element.total_discount_value,
                designFee: 0,
                runChargeDetails: runChargeDetails
            };

            this.$forceUpdate();
        },
        calculateOldEmbroideryPricing(index) {
            const activeService = this.activeDecorationService;
            let gender_element = this.gender_groups[index];
            if (!gender_element) {
                return;
            }
            let total_group_quantity =
                this.getTotalItemQuantity(gender_element);
            // Reset all gender-level totals
            gender_element.total_discount_value = 0; // Promotional Discount
            gender_element.total_qty_gender_wise = 0;
            gender_element.total_cost_gender_wise = 0;
            gender_element.total_color_fee = 0;
            gender_element.subtotal = 0; // Item total (after decoration discount)
            this.setup_fee = 0;

            if (gender_element["selected_colors"]) {
                // Get tier price and discount ONCE
                let single_location_price = this.getDecorationPrice();
                let decoration_discount_percentage =
                    this.getDecorationDiscount();

                gender_element["selected_colors"].forEach(
                    (selected_color_obj) => {
                        // Reset color-level totals
                        selected_color_obj.total_qty_gender_wise = 0;
                        selected_color_obj.subtotal = 0;
                        selected_color_obj.total_cost_gender_wise = 0;

                        // Loop through each size
                        selected_color_obj["unique_sizes"].forEach((size) => {
                            // Store current tier's price and discount on the size object
                            size.single_location_price = single_location_price;
                            size.decoration_discount_percentage =
                                decoration_discount_percentage;

                            let base_price =
                                size.price_base || this.product.price_base;
                            const activeService = this.activeDecorationService;
                            let markup_percentage = activeService
                                ? activeService.markup_percentage
                                : this.product.price_markup_percentage;
                            let mark_up_cost =
                                (base_price * markup_percentage) / 100;
                            size.markup_price = mark_up_cost;
                            let color_category_price =
                                this.getDarkLightFees(selected_color_obj);

                            let decoration_discount_amount =
                                (parseFloat(size.single_location_price) *
                                    parseFloat(
                                        size.decoration_discount_percentage
                                    )) /
                                100;
                            let discounted_decoration_price =
                                parseFloat(size.single_location_price) -
                                decoration_discount_amount;

                            size.cost =
                                parseFloat(base_price) +
                                parseFloat(mark_up_cost) +
                                parseFloat(color_category_price) +
                                discounted_decoration_price;

                            // Calculate totals only if quantity exists
                            if (size.quantity && size.quantity > 0) {
                                size.total_cost =
                                    this.icPriceFormat(size.cost, true) *
                                    parseInt(size.quantity);
                                selected_color_obj.subtotal += parseFloat(
                                    size.total_cost
                                );
                                selected_color_obj.total_cost_gender_wise +=
                                    parseFloat(size.total_cost);
                                selected_color_obj.total_qty_gender_wise +=
                                    parseInt(size.quantity);
                            } else {
                                size.total_cost = 0;
                            }
                        });

                        // Aggregate up to the gender level
                        gender_element.subtotal += parseFloat(
                            selected_color_obj.subtotal
                        );
                        gender_element.total_qty_gender_wise += parseFloat(
                            selected_color_obj.total_qty_gender_wise
                        );
                    }
                );
            }

            const total_decoration_fee =
                this.calcImprintLocationByGender(index);
            this.setup_fee = this.calculateSetupFee(
                activeService,
                gender_element.total_qty_gender_wise,
                this.total_decoration_colors_count
            );
            const otherServicesTotal = this.otherServices.reduce(
                (total, service) => {
                    const cost = parseFloat(service.retail_cost) || 0;
                    if (service.fee_structure === "Per Item") {
                        return total + cost * total_group_quantity;
                    } else {
                        return total + cost;
                    }
                },
                0
            );

            const preDiscountTotal =
                gender_element.subtotal +
                total_decoration_fee +
                this.setup_fee +
                otherServicesTotal;

            let mainDiscountAmount = 0;
            const activeDiscount = this.activeProductDiscount;
            if (activeDiscount && preDiscountTotal > 0) {
                let discount_type = activeDiscount.discount_type;
                let discount_value = parseFloat(activeDiscount.discount_value);
                if (discount_type == "Percent") {
                    mainDiscountAmount =
                        (preDiscountTotal * discount_value) / 100;
                } else {
                    mainDiscountAmount = Math.min(
                        preDiscountTotal,
                        discount_value
                    );
                }
            }
            gender_element.total_discount_value = mainDiscountAmount;

            gender_element.total_color_fee = parseFloat(total_decoration_fee);
            gender_element.total_cost_gender_wise =
                preDiscountTotal - mainDiscountAmount;

            // Create run charge details array with full color breakdown
            const runChargeDetails = [];
            if (gender_element.total_color_fee > 0) {
                // Build detailed breakdown by location
                this.imprint_locations.forEach((location, locIndex) => {
                    if (location.is_selected && location.decoration_fee > 0) {
                        if (
                            location.is_full_color_selected &&
                            location.full_color_value
                        ) {
                            // Full color location
                            const locationName =
                                locIndex === 0
                                    ? "Location 1"
                                    : `Location ${locIndex + 1}`;
                            // Full Color entry removed - not added to runChargeDetails
                            // Add location fee if applicable (for additional locations)
                            if (
                                locIndex > 0 &&
                                location.total_decoration_fee >
                                    location.full_color_value *
                                        gender_element.total_qty_gender_wise
                            ) {
                                const locationFee =
                                    (location.total_decoration_fee -
                                        location.full_color_value *
                                            gender_element.total_qty_gender_wise) /
                                    gender_element.total_qty_gender_wise;
                                if (locationFee > 0) {
                                    // Location Fee entry removed - not added to runChargeDetails
                                }
                            }
                        } else {
                            // Regular color location
                            // Location-specific Run Charge entries removed - not showing in breakdown
                            // const locationName =
                            //     locIndex === 0
                            //         ? "Location 1"
                            //         : `Location ${locIndex + 1}`;
                            // runChargeDetails.push({
                            //     name: `${locationName} Run Charge`,
                            //     value: parseFloat(
                            //         location.decoration_fee.toFixed(2)
                            //     ),
                            //     unitPrice: parseFloat(
                            //         location.decoration_fee.toFixed(2)
                            //     ),
                            //     quantity: gender_element.total_qty_gender_wise
                            // });
                        }
                    }
                });

                // If no detailed breakdown, add general location run charge
                // if (runChargeDetails.length === 0) {
                //     runChargeDetails.push({
                //         name: "Location(s) Run Charge",
                //         value: parseFloat(
                //             gender_element.total_color_fee.toFixed(2)
                //         )
                //     });
                // }
            }

            this.currentBreakdown = {
                baseCost: gender_element.subtotal,
                runCharge: gender_element.total_color_fee,
                setupFee: this.setup_fee,
                totalCost: gender_element.total_cost_gender_wise,
                totalDiscount: gender_element.total_discount_value,
                designFee: 0,
                runChargeDetails: runChargeDetails
            };
            this.$forceUpdate();
        },

        calculateSetupFee(activeService, totalQuantity, totalColors) {
            if (
                !activeService ||
                !activeService.master_service ||
                totalQuantity <= 0
            ) {
                return 0;
            }

            const pricing = activeService.master_service;
            const feeStructure = pricing.fee_structure;
            let calculatedFee = 0;

            // Check if any location has full color selected
            let hasFullColor = false;
            if (this.imprint_locations && this.imprint_locations.length > 0) {
                hasFullColor = this.imprint_locations.some(
                    (location) =>
                        location.is_selected &&
                        (location.is_full_color_selected === true ||
                            location.no_of_color === "full_color")
                );
            }

            // If full color is selected, use setup_fee_multicolor
            if (hasFullColor) {
                calculatedFee = parseFloat(pricing.setup_fee_multicolor || 0);
            } else {
                // Normal logic when full color is not selected
                if (feeStructure == "1") {
                    calculatedFee =
                        parseFloat(pricing.setup_fee_color1 || 0) * totalColors;
                } else if (feeStructure == "2") {
                    if (totalColors === 1) {
                        calculatedFee = parseFloat(
                            pricing.setup_fee_color1 || 0
                        );
                    } else if (totalColors > 1) {
                        calculatedFee = parseFloat(
                            pricing.setup_fee_multicolor || 0
                        );
                    }
                }
            }
            return calculatedFee;
        },
        getDecorationPrice(
            colorIndex = 0,
            locationIndex = undefined,
            additional = false
        ) {
            let qty_wise_color_price = 0;

            let total_qty_gender_wise = this.getTotalItemQuantity(
                this.gender_groups[this.is_active]
            );

            if (this.product.decoration_type == 1) {
                let decoration_data;

                if (!additional) {
                    decoration_data =
                        this.product.price_decoration_bulk.print_location1;
                } else {
                    decoration_data =
                        this.product.price_decoration_bulk.print_location2;
                }

                let total_group_quantity =
                    parseInt(total_qty_gender_wise) +
                    parseInt(this.current_cart_quantity);
                for (const [index, element] of Object.entries(
                    decoration_data
                )) {
                    if (
                        element.quantity <= total_group_quantity ||
                        index == 0
                    ) {
                        qty_wise_color_price =
                            element[`colour${colorIndex + 1}`];
                    }
                }
            } else if (this.product.decoration_type == 2) {
                let decoration_data = this.product.price_decoration_bulk;
                let total_group_quantity =
                    parseInt(total_qty_gender_wise) +
                    parseInt(this.current_cart_quantity);
                for (const [index, element] of Object.entries(
                    decoration_data
                )) {
                    if (
                        element.quantity1 <= total_group_quantity ||
                        index == 0
                    ) {
                        if (locationIndex > 0) {
                            qty_wise_color_price =
                                element[`location${locationIndex + 1}`];
                        } else {
                            qty_wise_color_price = element["cost"];
                        }
                    }
                }
            }

            return parseFloat(qty_wise_color_price || 0);
        },

        getDecorationDiscount(additional = false) {
            let discount = 0;

            let total_qty_gender_wise = this.getTotalItemQuantity(
                this.gender_groups[this.is_active]
            );

            if (this.product.decoration_type == 1) {
                let decoration_data;

                if (!additional) {
                    decoration_data =
                        this.product.price_decoration_bulk.print_location1;
                } else {
                    decoration_data =
                        this.product.price_decoration_bulk.print_location2;
                }

                let total_group_quantity =
                    parseInt(total_qty_gender_wise) +
                    parseInt(this.current_cart_quantity);
                for (const [index, element] of Object.entries(
                    decoration_data
                )) {
                    if (
                        element.quantity <= total_group_quantity ||
                        index == 0
                    ) {
                        discount = element["discount"];
                    }
                }
            } else if (this.product.decoration_type == 2) {
                let decoration_data = this.product.price_decoration_bulk;
                let total_group_quantity =
                    parseInt(total_qty_gender_wise) +
                    parseInt(this.current_cart_quantity);
                for (const [index, element] of Object.entries(
                    decoration_data
                )) {
                    if (
                        element.quantity1 <= total_group_quantity ||
                        index == 0
                    ) {
                        discount = element["discount"];
                    }
                }
            }

            return parseFloat(discount || 0);
        },

        onChangeGenderColor() {
            let _this = this;
            let thumb_array = [];
            let normal_array = [];
            let common_thumb_array = [];
            let common_normal_array = [];

            // Get selected colors array (maintains FIFO order)
            let selected_colors = [];
            if (
                _this.gender_groups &&
                _this.gender_groups[_this.is_active] &&
                _this.gender_groups[_this.is_active]["selected_colors"] &&
                Array.isArray(_this.gender_groups[_this.is_active]["selected_colors"])
            ) {
                selected_colors = _this.gender_groups[_this.is_active]["selected_colors"];
            }

            if (_this.product.NewProductImages) {
                // First, add images for each selected color in FIFO order (first selected first)
                if (selected_colors.length > 0) {
                    selected_colors.forEach((selectedColor) => {
                        _this.product.NewProductImages.forEach((element) => {
                            if (
                                element.color_id &&
                                element.color_id == selectedColor.id
                            ) {
                                thumb_array.push({
                                    id: element.id,
                                    url: element.url,
                                    thumb_url: element.thumbnail,
                                    type: "image"
                                });
                                normal_array.push({
                                    id: element.id,
                                    url: element.url,
                                    type: "image"
                                });
                            }
                        });
                    });
                }

                // Then, add all generic images (without color_id) at the end
                _this.product.NewProductImages.forEach((element) => {
                    if (!element.color_id) {
                        common_thumb_array.push({
                            id: element.id,
                            url: element.url,
                            thumb_url: element.thumbnail,
                            type: "image"
                        });
                        common_normal_array.push({
                            id: element.id,
                            url: element.url,
                            type: "image"
                        });
                    }
                });
            }

            // Combine color-specific images first (in FIFO order), then generic images
            let final_thumb_array = [...thumb_array, ...common_thumb_array];
            let final_normal_array = [...normal_array, ...common_normal_array];

            // Add video if it exists
            if (
                _this.product.video_url &&
                _this.product.video_url.trim() != ""
            ) {
                final_thumb_array.push({
                    id: _this.product.id,
                    url: _this.product.video_url,
                    thumb_url: _this.product.video_url,
                    type: "video"
                });
                final_normal_array.push({
                    id: _this.product.id,
                    url: _this.product.video_url,
                    type: "video"
                });
            }

            _this.images = {
                thumbs: final_thumb_array,
                normal_size: final_normal_array
            };
        },

        getFavoriteProduct(product) {
            var _this = this;
            if (_this.currentUserClient.id) {
                new Promise(() => {
                    _this.isBusy = true;
                    ApiService.get("/favorite-product/" + product.id)
                        .then(({ data }) => {
                            _this.favorite_product = data.favorite_product;
                            _this.is_favorite_product = data.favorite_product.id
                                ? true
                                : false;
                            _this.isBusy = false;
                        })
                        .catch(({ response }) => {
                            console.log(response);
                        });
                });
            }
        },

        addToFavorite(product) {
            var _this = this;
            // setTimeout(() => {
            if (_this.currentUserClient.id) {
                new Promise(() => {
                    // _this.isBusy = true;
                    let post_data = { product_id: product.id };
                    ApiService.post("/favorite-product", post_data)
                        .then(({ data }) => {
                            if (data.success) {
                                _this.$toast.success(data.message, {
                                    position: "top-right",
                                    queue: true
                                });
                            }
                            _this.is_favorite_product = true;
                            _this.getFavoriteProduct(_this.product);
                            // _this.isBusy = false;
                        })
                        .catch(({ response }) => {
                            console.log(response);
                        });
                });
            }
            // }, 1000);
        },

        getGendersGroups(gendersGroup) {
            return new Promise((resolve, reject) => {
                ApiService.post("/gender-age-sizes-byIds/", gendersGroup)
                    .then(({ data }) => {
                        if (data.success == true) {
                            data.genderagesize.forEach((elem) => {
                                let allsizes = [];
                                let usizes = [];
                                let sizes = JSON.parse(elem.sizes);
                                // sizes.forEach(element => {
                                this.product.MainNewSubProducts.forEach(
                                    (elm) => {
                                        if (sizes.includes(elm.size_id)) {
                                            if (
                                                !allsizes.find(
                                                    (s) =>
                                                        s.size_id == elm.size_id
                                                )
                                            ) {
                                                usizes.push(elm);
                                            }
                                            allsizes.push(elm);
                                        }
                                    }
                                );
                                // });
                                if (allsizes.length > 0) {
                                    this.gender_groups.push({
                                        id: elem.id,
                                        prod_type_id: elem.prod_type_id,
                                        gender: elem.gender,
                                        total_cost_gender_wise: 0,
                                        total_qty_gender_wise: 0,
                                        total_cost: 0,
                                        sizes: allsizes,
                                        selected_colors: []
                                    });
                                }
                            });
                        } else {
                            this.$toast.error(data.error, {
                                position: "top-right"
                            });
                        }
                        resolve(data);
                    })
                    .catch((error) => {
                        console.log(error);
                        reject(error);
                    });
            });
        },

        loadVendorColors(product) {
            this.imprint_colors_array_for_template = [];
            if (product.Decorators && product.Decorators.length) {
                let vendorColors = [];
                if (product.default_decorator_id) {
                    let default_decorator = product.Decorators.find(
                        (decorator) =>
                            decorator.id == product.default_decorator_id
                    );
                    vendorColors = default_decorator.VendorColors;
                } else {
                    vendorColors = product.Decorators[0].VendorColors;
                }
                // Added Colors
                if (vendorColors.length > 0) {
                    for (const color of vendorColors) {
                        let colorExist =
                            this.imprint_colors_array_for_template.find(
                                (vendorColor) =>
                                    vendorColor.color_id == color.color_id
                            );
                        if (!color.Color || colorExist) {
                            continue;
                        }
                        let colorsData = {
                            color_id: color.color_id,
                            color_name: color.Color.name,
                            color_pms: color.Color.pms,
                            decor_upcharge: color.decor_upcharge,
                            color_value: color.Color.hex,
                            swatches: color.Color.swatches,
                            category: color.Color.category,
                            shades: color.Color.shades
                                ? JSON.parse(color.Color.shades)
                                : []
                        };

                        if (
                            color.Color.type == "ink" &&
                            this.decoration_type == 1
                        ) {
                            this.imprint_colors_array_for_template.push(
                                colorsData
                            );
                        } else if (
                            color.Color.type == "thread" &&
                            this.decoration_type == 2
                        ) {
                            this.imprint_colors_array_for_template.push(
                                colorsData
                            );
                        } else if (
                            color.Color.type == "vinyl" &&
                            this.decoration_type != 1 &&
                            this.decoration_type != 2
                        ) {
                            this.imprint_colors_array_for_template.push(
                                colorsData
                            );
                        }
                    }
                    // Added new color Data in Product objects
                    if (product.Vendor) {
                        this.product.Vendor.newVendorColors =
                            this.imprint_colors_array_for_template;
                    }
                } else if (product.Vendor) {
                    let vendor_colors = product.Vendor.vendor_colors
                        ? JSON.parse(product.Vendor.vendor_colors)
                        : [];

                    if (this.decoration_type == 1) {
                        this.imprint_colors_array_for_template =
                            vendor_colors.color_data_for_ink;
                    } else if (this.decoration_type == 2) {
                        this.imprint_colors_array_for_template =
                            vendor_colors.color_data_for_thread;
                    } else {
                        this.imprint_colors_array_for_template =
                            vendor_colors.color_data_for_vinyl;
                    }
                }
            }
        },

        // Get Product Images
        // getProductImages(color_id = null) {
        //     let _this = this;
        //     let thumb_array = [];
        //     let normal_array = [];
        //     return new Promise(() => {
        //         ApiService.get(
        //             "/get-main-product-images/" +
        //                 this.$route.params.id_of_product
        //         ).then(({ data }) => {
        //             _this.product.NewProductImages = data.product_images;
        //             if (_this.product.NewProductImages) {
        //                 // First, add generic images (those without a color_id)
        //                 _this.product.NewProductImages.forEach((element) => {
        //                     if (!element.color_id) {
        //                         thumb_array.push({
        //                             id: element.id,
        //                             url: element.url,
        //                             thumb_url: element.thumbnail,
        //                             type: "image"
        //                         });
        //                         normal_array.push({
        //                             id: element.id,
        //                             url: element.url,
        //                             type: "image"
        //                         });
        //                     }
        //                 });

        //                 // Then, if a color is selected, add its specific images
        //                 if (color_id) {
        //                     _this.product.NewProductImages.forEach(
        //                         (element) => {
        //                             if (element.color_id == color_id) {
        //                                 thumb_array.push({
        //                                     id: element.id,
        //                                     url: element.url,
        //                                     thumb_url: element.thumbnail,
        //                                     type: "image"
        //                                 });
        //                                 normal_array.push({
        //                                     id: element.id,
        //                                     url: element.url,
        //                                     type: "image"
        //                                 });
        //                             }
        //                         }
        //                     );
        //                 }

        //                 _this.images = {
        //                     thumbs: thumb_array,
        //                     normal_size: normal_array
        //                 };
        //             }
        //         });
        //     });
        // },

        getProductImages(color_id = null) {
            let _this = this;
            let thumb_array = [];
            let normal_array = [];
            let common_thumb_array = [];
            let common_normal_array = [];

            // We return the ApiService.get() promise directly
            return ApiService.get(
                "/get-main-product-images/" + this.$route.params.id_of_product
            ).then(({ data }) => {
                _this.product.NewProductImages = data.product_images;

                if (_this.product.NewProductImages) {
                    // First, add all images with the selected color_id
                    if (color_id) {
                        _this.product.NewProductImages.forEach((element) => {
                            if (element.color_id == color_id) {
                                thumb_array.push({
                                    id: element.id,
                                    url: element.url,
                                    thumb_url: element.thumbnail,
                                    type: "image"
                                });
                                normal_array.push({
                                    id: element.id,
                                    url: element.url,
                                    type: "image"
                                });
                            }
                        });
                    }

                    // Then, add all generic images (without color_id) at the end
                    _this.product.NewProductImages.forEach((element) => {
                        if (!element.color_id) {
                            common_thumb_array.push({
                                id: element.id,
                                url: element.url,
                                thumb_url: element.thumbnail,
                                type: "image"
                            });
                            common_normal_array.push({
                                id: element.id,
                                url: element.url,
                                type: "image"
                            });
                        }
                    });

                    // Combine color-specific images first, then generic images
                    let final_thumb_array = [...thumb_array, ...common_thumb_array];
                    let final_normal_array = [...normal_array, ...common_normal_array];

                    // Add video if it exists
                    if (
                        _this.product.video_url &&
                        _this.product.video_url.trim() != ""
                    ) {
                        final_thumb_array.push({
                            id: _this.product.id,
                            url: _this.product.video_url,
                            thumb_url: _this.product.video_url,
                            type: "video"
                        });
                        final_normal_array.push({
                            id: _this.product.id,
                            url: _this.product.video_url,
                            type: "video"
                        });
                    }

                    _this.images = {
                        thumbs: final_thumb_array,
                        normal_size: final_normal_array
                    };
                }
            });
        },

        prepareDecorationPrices(decoration_type, price_decoration_bulk) {
            this.product.price_decoration_bulk = price_decoration_bulk;
            const activeService = this.activeDecorationService;

            let noOfColorsCount = 0;
            if (activeService) {
                // Prioritize the new max_colors property from the active service
                if (activeService.max_colors) {
                    noOfColorsCount = activeService.max_colors;
                } else if (activeService.use_imprintcity_price_template === 1) {
                    // Fallback to old template logic if max_colors isn't available
                    if (decoration_type == 1 && this.product.PrintTemplate) {
                        noOfColorsCount =
                            this.product.PrintTemplate.no_of_colors;
                    } else if (
                        decoration_type == 2 &&
                        this.product.Embroidery
                    ) {
                        noOfColorsCount = this.product.Embroidery.no_of_colors;
                    }
                } else {
                    // Default for new PCNA-style services if max_colors is missing
                    noOfColorsCount = 6;
                }
            }

            // Build the options array for the color dropdown
            this.imprintcityColors = [];
            // Check if full color option should be shown
            if (activeService && activeService.is_full_color === true) {
                // Show only "1 color" and "Full color" options
                this.imprintcityColors.push({
                    id: 1,
                    value: "1-color"
                });
                this.imprintcityColors.push({
                    id: "full_color",
                    value: "Full color"
                });
            } else if (noOfColorsCount > 0) {
                // Normal color options
                for (let i = 1; i <= noOfColorsCount; i++) {
                    this.imprintcityColors.push({
                        id: i,
                        value: `${i}-color${i > 1 ? "s" : ""}` // e.g., "1-color", "2-colors"
                    });
                }
            }

            // The rest of the method now only handles pricing tiers, not the color dropdown options.
            if (
                activeService &&
                activeService.use_imprintcity_price_template === 0
            ) {
                //NEW STRUCTURE LOGIC
                this.decoration_price_template_values = price_decoration_bulk;

                if (price_decoration_bulk && price_decoration_bulk.length > 0) {
                    this.minimum_quantity_decoration_fee =
                        price_decoration_bulk[0].retail_cost;
                }
            } else {
                //OLD STRUCTURE LOGIC (with safety checks)
                if (decoration_type == 1) {
                    if (!this.product.PrintTemplate) return; // Prevents crash if template isn't loaded

                    if (this.product.PrintTemplate.discount_enable) {
                        price_decoration_bulk.print_location1.forEach((row) => {
                            for (
                                let i = 1;
                                i < this.product.PrintTemplate.no_of_colors;
                                i++
                            ) {
                                let discount_colour =
                                    (parseFloat(row[`colour${i}`]) *
                                        parseFloat(row.discount)) /
                                    100;
                                row[`colour${i}`] = parseFloat(
                                    parseFloat(row[`colour${i}`]) -
                                        parseFloat(discount_colour)
                                ).toFixed(2);
                            }
                        });
                    }

                    this.decoration_price_template_values =
                        price_decoration_bulk.print_location1;
                    this.decoration_price_template_location2 =
                        price_decoration_bulk.print_location2;
                    if (
                        this.decoration_price_template_values &&
                        this.decoration_price_template_values.length > 0
                    ) {
                        this.minimum_quantity_decoration_fee =
                            this.decoration_price_template_values[0].colour1;
                    }
                } else if (decoration_type == 2) {
                    if (!this.product.Embroidery) return; // Prevents crash if template isn't loaded

                    this.decoration_price_template_values =
                        price_decoration_bulk;
                    if (
                        this.decoration_price_template_values &&
                        this.decoration_price_template_values.length > 0
                    ) {
                        this.minimum_quantity_decoration_fee =
                            this.decoration_price_template_values[0].cost;
                    }
                } else if (decoration_type == 3) {
                    this.decoration_price_template_values =
                        price_decoration_bulk;
                }
            }
        },

        getCompanionProduct(id) {
            let companion_values = {
                parent_id: id,
                t_shirt_24_hour: this.is_tshirt_24_hour
            };
            new Promise(() => {
                ApiService.post(
                    "/home-companion-new-product-new",
                    companion_values
                )
                    .then(({ data }) => {
                        this.companion_products = data.product;
                        this.companion_products.forEach((product) => {
                            product["default_color_id"] = null;
                            if (product.MainNewSubProducts) {
                                if (this.is_tshirt_24_hour) {
                                    product.MainNewSubProducts =
                                        product.MainNewSubProducts.filter(
                                            (sub_product_data) =>
                                                sub_product_data.Color.name ==
                                                "White"
                                        );
                                }
                                let sub_product =
                                    product.MainNewSubProducts.find(
                                        (sub_product) =>
                                            sub_product.default_selection
                                    );
                                if (sub_product) {
                                    product["default_color_id"] =
                                        sub_product.color_id;
                                }
                            }

                            if (
                                product.decoration_price_type == "global_price"
                            ) {
                                product.price_markup_percentage =
                                    this.getMarkupFromTier(
                                        product.price_base,
                                        product.decoration_type,
                                        product.decoration_price_template
                                    );
                                product.price_markup_value =
                                    (parseFloat(product.price_base) *
                                        parseFloat(
                                            product.price_markup_percentage
                                        )) /
                                    100;
                                if (product.decoration_type == 1) {
                                    let decoration_price_template =
                                        this.printTemplates.find(
                                            (template) =>
                                                template.id ==
                                                product.decoration_price_template
                                        );
                                    if (decoration_price_template) {
                                        product.PrintTemplate =
                                            decoration_price_template;
                                        product.price_color_category_dark =
                                            decoration_price_template.price_dark;
                                        product.price_color_category_light =
                                            decoration_price_template.price_light;
                                        product.price_decoration_bulk =
                                            JSON.stringify({
                                                print_location1:
                                                    decoration_price_template.PrintLocation1Templates
                                            });
                                    }
                                } else if (product.decoration_type == 2) {
                                    let decoration_price_template =
                                        this.embroideryTemplates.find(
                                            (template) =>
                                                template.id ==
                                                product.decoration_price_template
                                        );
                                    if (decoration_price_template) {
                                        product.EmbroideryTemplate =
                                            decoration_price_template;
                                        product.price_color_category_dark =
                                            decoration_price_template.price_dark;
                                        product.price_color_category_light =
                                            decoration_price_template.price_light;
                                        product.price_decoration_bulk =
                                            JSON.stringify(
                                                decoration_price_template.EmbroideryQuantities
                                            );
                                    }
                                }
                            }
                        });
                    })
                    .catch((response) => {
                        console.log(response);
                    });
            });
        },

        getMoreDecorations(more_decoration) {
            this.design_fee = 0;
            return new Promise((resolve, reject) => {
                if (more_decoration) {
                    let decoration_values = more_decoration
                        ? more_decoration
                        : [];
                    let more_decoration_values = {
                        decoration_ids: decoration_values
                    };
                    ApiService.post(
                        "/home-decoration-values",
                        more_decoration_values
                    )
                        .then(({ data }) => {
                            this.more_decoration_list = data.decoration;
                            this.more_decoration_list.forEach((decoration) => {
                                this.design_fee += parseFloat(decoration.price);
                            });
                            this.design_fee = parseFloat(
                                parseFloat(this.design_fee).toFixed(2)
                            );
                            resolve(data);
                        })
                        .catch((err) => {
                            console.log(err);
                            reject(err);
                        });
                }
                resolve();
            });
            // return false;
        },

        activeLink(index) {
            var _this = this;
            let currTab = _this.is_active;
            _this.is_active = index;
            /* eslint-disable */
            _this.images = jQuery.extend(true, {}, _this.temp_img);
            /* eslint-enable */
            this.onChangeGenderColor();
            if (currTab !== index) {
                _this.is_imprint_location = false;
            }

            if (this.gender_groups[this.is_active]) {
                const selected_color_ids = this.gender_groups[
                    this.is_active
                ].selected_colors.map((color) => color.id);
                this.colors.forEach((color) => {
                    color.is_selected = selected_color_ids.includes(color.id);
                });
            }
        },

        showMore(list) {
            var _this = this;
            _this[list] = _this[list] ? false : true;
        },

        getTiers() {
            var _this = this;
            new Promise(() => {
                ApiService.get("/tiers")
                    .then(({ data }) => {
                        _this.tier_list = data.tiers;
                    })
                    .catch(({ response }) => {
                        if (response.status == 401) {
                            _this.$router.push({ name: "/admin/login" });
                        }
                    });
            });
        },

        tireName(tier) {
            var unit_names = [];
            let tier_name = "";
            this.tier_list.forEach((element) => {
                if (tier == element.id) {
                    element.TierUnits.forEach((elm) => {
                        tier_name = element.name;
                        let unit_value =
                            `<div class="col pl-0 mx_2"> <p class="m-0">` +
                            elm.quantity +
                            `</p><p class="m-0">$` +
                            elm.price.toFixed(2) +
                            `</p></div>`;
                        unit_names.push(unit_value);
                    });
                }
            });

            let final_html =
                `<div class="dropdown">
<a href="#" class="dropdown-toggle" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">` +
                tier_name +
                `
</a>
<div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
<h4 class="font_size_16 text_primary_blue py_2 px_20">Tier</h4>
<div class="scroll">
<div class="dropdown-item d-flex align-items-center">
` +
                unit_names.join(" ") +
                `
</div></div> </div></div>`;

            return final_html;
        },

        // getCartItems() {
        //     new Promise((resolve, reject) => {
        //         ApiService.get("/cart")
        //             .then(({ data }) => {
        //                 this.cart_items = data.cart_items;
        //                 this.updateCartQuantity();
        //                 if (data.max_cart_count) {
        //                     this.max_cart_count = parseInt(data.max_cart_count);
        //                 }
        //                 resolve(data);
        //             })
        //             .catch((err) => {
        //                 console.log(err);
        //                 reject(err);
        //             });
        //     });
        // },

        getUrlExtension(url) {
            if (!url) {
                return false;
            }
            let matchs = url.includes("data:application/pdf;base64");
            let postscript = url.includes("data:application/postscript;base64");
            if (postscript && this.images_name) {
                url = this.images_name.split(".")[1];
                return url;
            }
            if (matchs) {
                url = "pdf";
                return url;
                // return url.split(/[#?]/)[0].split('.').pop().trim();
            }
            return url.split(/[#?]/)[0].split(".").pop().trim();
        },

        isValidHttpUrl(string) {
            let url;
            try {
                url = new URL(string);
            } catch (_) {
                return false;
            }
            return url.protocol === "http:" || url.protocol === "https:";
        },

        async changeDecorationService(index, isInitialLoad = false) {
            if (!this.product || !this.product.id) {
                return;
            }
            if (!isInitialLoad) {
                this.isBusy = true;
            }
            this.decoration_services.forEach((item, indx) => {
                item.isActive = indx === index;
            });

            this.product.PrintTemplate = null;
            this.product.Embroidery = null;

            if (this.product && this.product.design_areas) {
                this.resetImprintLocations(
                    JSON.parse(this.product.design_areas)
                );
            }

            const activeService = this.activeDecorationService;

            if (activeService) {
                const liveServiceData =
                    this.product.VendorDecorationServices.find(
                        (s) => s.id === activeService.id
                    );
                if (liveServiceData) {
                    // Overwrite the master_service in our decoration_services array with live data
                    activeService.master_service = liveServiceData;
                }
                // If it's a PCNA case, fetch ONLY the live fees
                if (activeService.use_imprintcity_price_template === 0) {
                    this.filterOtherServices();
                }
                // For old logic, fetch the PrintTemplate if needed
                else if (activeService.decoration_price_template) {
                    await this.$store
                        .dispatch(FETCH_DECORATION_TEMPLATE, {
                            decoration_type: activeService.decoration_type,
                            decoration_price_template_id:
                                activeService.decoration_price_template
                        })
                        .then(() => {
                            if (activeService.decoration_type === 1)
                                this.product.PrintTemplate =
                                    this.decorationTemplate;
                            else if (activeService.decoration_type === 2)
                                this.product.Embroidery =
                                    this.decorationTemplate;
                        });
                }

                this.decoration_type = activeService.decoration_type || 1;
                this.product.decoration_type =
                    activeService.decoration_type || 1;

                this.prepareDecorationPrices(
                    this.product.decoration_type,
                    activeService.price_decoration_bulk
                );
                this.getMoreDecorations(activeService.more_decorations).then(
                    () => {
                        this.calculatePricing(this.is_active);
                    }
                );
                this.loadVendorColors(this.product);
            }

            if (!isInitialLoad) {
                this.isBusy = false;
            }
        },

        getDecorationMethods() {
            return new Promise((resolve, reject) => {
                ApiService.get("/decoration-methods")
                    .then(({ data }) => {
                        this.decoration_methods = data.decoration_methods;
                        resolve(data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getDecorationPriceFromTemplateIds() {
            let config_data = {
                print_template_ids: this.print_templates_id,
                embroidery_template_ids: this.embroidery_template_ids,
                promotional_template_ids: this.promotional_template_ids
            };
            return new Promise((resolve, reject) => {
                ApiService.post("/get-decoration-pricing", config_data)
                    .then(({ data }) => {
                        resolve(data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        showBreakupCharges(gender) {
            if (
                this.setup_fee_applied_gender_index >= 0 &&
                this.setup_fee > 0
            ) {
                return true;
            } else if (gender.total_discount_value > 0) {
                return true;
            } else if (gender.total_design_fee > 0) {
                return true;
            } else if (gender.total_color_fee > 0) {
                return true;
            }

            return false;
        },

        shareOnFacebook() {
            const navUrl =
                "https://www.facebook.com/sharer/sharer.php?u=" +
                this.site_url +
                "product-details/" +
                this.product.id;
            window.open(navUrl, "_blank");
        },

        shareOnTwitter() {
            const navUrl =
                "https://twitter.com/intent/tweet?url=" +
                this.site_url +
                "product-details/" +
                this.product.id +
                "&text=Hello+Everyone+I+found+this+awesome+customisable+product+by+Imprint+City&hashtags=imprintCity,customizedPersonal,brand";
            window.open(navUrl, "_blank");
        },

        shareOnInstagram() {
            const navUrl =
                "https://www.instagram.com/sharer/sharer.php?u=" +
                this.site_url +
                "product-details/" +
                this.product.id +
                "&text=Hello+Everyone+I+found+this+awesome+customisable+product+by+Imprint+City&hashtags=imprintCity,customizedPersonal,brand";
            window.open(navUrl, "_blank");
        },

        updateCartQuantity(recalculate = false) {
            // this.current_cart_quantity = 0;
            // let selected_color_ids = [];
            // if (this.gender_groups[this.is_active]) {
            //     selected_color_ids = this.gender_groups[this.is_active].selected_colors.map(color => color.id);
            // }

            // this.same_artwork_cart_items = [];
            // if (this.product_artwork) {
            //     this.cart_items.forEach(item => {
            //         if (!item.build_id && (item.item_id == this.product.id)) {
            //             if (!selected_color_ids.includes(item.color_id) && (this.product_artwork == item.artwork)) {
            //                 this.current_cart_quantity += parseInt(item.total_quantity);
            //                 let cart_item = JSON.parse(JSON.stringify(item));
            //                 cart_item.imprint_locations = cart_item.imprint_locations
            //                     ? JSON.parse(cart_item.imprint_locations)
            //                     : []
            //                 this.same_artwork_cart_items.push(cart_item);
            //             } else if (selected_color_ids.includes(item.color_id) && (this.product_artwork == item.artwork)) {
            //                 this.gender_groups[this.is_active].selected_colors.forEach(selectedColor => {
            //                     if (selectedColor.id === item.color_id) {
            //                         selectedColor.existing_cart_quantity = parseInt(item.total_quantity);
            //                     }
            //                 })
            //             }
            //         }

            //     })
            // }

            if (recalculate) {
                this.calculatePricing(this.is_active);
            }
        },

        recalculateCartItems(cart_items) {
            let total_group_quantity = this.getTotalItemQuantity(
                this.gender_groups[this.is_active]
            );
            let single_location_price = this.calculateCostOfQtyForPrint(
                total_group_quantity + this.current_cart_quantity
            );

            cart_items.forEach((cart_item) => {
                cart_item.total_price =
                    parseFloat(cart_item.total_price) -
                    parseFloat(cart_item.subtotal_price) -
                    parseFloat(cart_item.imprint_locations_price);
                cart_item.imprint_locations_price = 0;
                cart_item.subtotal_price = 0;

                // UPDATING PRICES WITH NEW SINGLE LOCATION FOR EACH SIZE
                cart_item.CartChildItems.forEach((childItem) => {
                    childItem.unit_price =
                        parseFloat(childItem.unit_price) -
                        parseFloat(childItem.single_location_price);

                    childItem.total_price =
                        parseFloat(childItem.total_price) -
                        parseFloat(childItem.single_location_price) *
                            parseInt(childItem.quantity);

                    childItem.single_location_price = single_location_price;
                    childItem.unit_price =
                        parseFloat(childItem.unit_price) +
                        parseFloat(childItem.single_location_price);
                    childItem.total_price =
                        parseFloat(childItem.total_price) +
                        parseFloat(childItem.single_location_price) *
                            parseInt(childItem.quantity);

                    cart_item.subtotal_price =
                        parseFloat(cart_item.subtotal_price) +
                        parseFloat(childItem.total_price);
                });

                // UPDATING IMPRINT LOCATIONS PRICE WITH NEW SINGLE LOCATION
                if (cart_item.imprint_locations) {
                    let highest_price_location_index =
                        this.getHighestPriceLocation(
                            cart_item.imprint_locations
                        );
                    cart_item.imprint_locations.forEach(
                        (location, locationIndex) => {
                            location.colors.forEach(
                                (imprint_color, colorIndex) => {
                                    let qty_wise_color_price =
                                        this.getDecorationPrice(
                                            colorIndex,
                                            this.is_active,
                                            this.product.decoration_type
                                        );

                                    if (
                                        highest_price_location_index ==
                                        locationIndex
                                    ) {
                                        qty_wise_color_price =
                                            this.getDecorationPrice(
                                                colorIndex,
                                                this.is_active,
                                                this.product.decoration_type
                                            );
                                    } else {
                                        qty_wise_color_price =
                                            this.getDecorationPrice(
                                                colorIndex,
                                                this.is_active,
                                                this.product.decoration_type,
                                                true
                                            );
                                    }
                                    if (
                                        highest_price_location_index ==
                                            locationIndex &&
                                        colorIndex == 0
                                    ) {
                                        qty_wise_color_price = 0;
                                    }
                                    imprint_color.cost_cost =
                                        qty_wise_color_price *
                                        parseInt(cart_item.total_quantity);
                                    if (
                                        imprint_color.color &&
                                        imprint_color.color.decor_upcharge !==
                                            undefined &&
                                        imprint_color.color.decor_upcharge !==
                                            null
                                    ) {
                                        imprint_color.decor_upcharge.color_cost =
                                            parseFloat(
                                                imprint_color.color
                                                    .decor_upcharge || 0
                                            ) *
                                            parseInt(cart_item.total_quantity);
                                        cart_item.imprint_locations_price =
                                            parseFloat(
                                                imprint_color.cost_cost || 0
                                            ) +
                                            parseFloat(
                                                imprint_color.decor_upcharge
                                                    .color_cost || 0
                                            );
                                    } else if (
                                        imprint_color.color &&
                                        imprint_color.cost_cost
                                    ) {
                                        cart_item.imprint_locations_price =
                                            parseFloat(
                                                imprint_color.cost_cost || 0
                                            );
                                    }
                                }
                            );
                        }
                    );

                    cart_item.total_price =
                        parseFloat(cart_item.total_price) +
                        parseFloat(cart_item.imprint_locations_price);
                }

                cart_item.total_price =
                    parseFloat(cart_item.total_price) +
                    cart_item.subtotal_price;
            });
        },

        getDarkLightFees(color) {
            const activeService = this.activeDecorationService;
            if (color && activeService) {
                if (color.category == "Dark") {
                    return parseFloat(activeService.price_dark || 0);
                } else if (color.category == "Light") {
                    return parseFloat(activeService.price_light || 0);
                }
            }
            return 0;
        },

        getAllMarkupTiers() {
            return new Promise((resolve, reject) => {
                ApiService.get("/get-markup-tiers")
                    .then(({ data }) => {
                        if (data.error) {
                            this.$toast.error(data.error, {
                                position: "top-right",
                                queue: true
                            });
                            return;
                        }
                        this.markup_tiers = data.markup_tiers;
                        resolve(data);
                    })
                    .catch((response) => {
                        reject(response);
                    });
            });
        },

        getMarkupFromTier(price, decoration_type, decoration_price_template) {
            let markup = 0;
            let tier = this.markup_tiers.find(
                (tier) =>
                    decoration_type == tier.decoration_id &&
                    decoration_price_template == tier.template_id &&
                    parseFloat(tier.start_price) <= parseFloat(price) &&
                    parseFloat(tier.end_price) >= parseFloat(price)
            );
            if (tier) {
                markup = tier.markup;
            }
            return markup;
        }
    },
    filters: {
        capitalize: function (value) {
            if (!value) {
                return "";
            }
            return value.toString().toUpperCase();
        }
    },
    watch: {
        // isAuthenticatedClient: function (val) {
        //     if (val) {
        //         setTimeout(() => {
        //             this.UploadedImages();
        //         }, 100);
        //     }
        // }
    }
};
</script>
<style>

button.add_artwork_preview_popup_btn {
    z-index: 1;
    position: relative;
}

.pricing-table {
    border: 1px solid #dee2e6;
    margin-bottom: 0;
}

.pricing-table th,
.pricing-table td {
    border: 1px solid #dee2e6;
    padding: 0.5rem 0.75rem;
    vertical-align: middle;
    white-space: nowrap;
}

.pricing-table thead th {
    border-bottom-width: 2px;
    background-color: #f8f9fa;
    font-weight: normal;
    color: #495057;
}

.pricing-table .text-left {
    text-align: left !important;
}

.pricing-table td:first-child {
    background-color: #f8f9fa;
}
.preview-disabled {
    cursor: not-allowed;
    pointer-events: none;
}
.product_details_update_v3
    .product_details_content
    .product_details_radio_btn
    .form__radio-group
    .form__label-radio {
    white-space: nowrap;
}
.product_details_update_v3
    .product_details_content
    .product_details_radio_btn
    .form__group {
    overflow-x: auto;
    padding-bottom: 5px;
}
.product_details_update_v3 .dropdown_colors .v-select{
    border: 1px solid #8080807a;
    padding: 0px 15px;
    background-color: #fff;
    border-radius: 7px;
    margin-top: 10px;
    height: 45px;
}
.product_details_update_v3 .right_section_main .right_section .popup_right_section .popup_dropdown .left-chest- .form-group .vs__selected-options .vs__search {
   border-bottom: none !important;
    font-size: 16px !important;
   padding: 15px 0px 0px 0px !important;
    padding-bottom: 0px !important;
    margin: 0px !important;
}

.product_details_update_v3 .dropdown_colors .vs__selected{
    font-size: 16px !important;
    top: 6px !important;
}

 .product_details_update_v3 .left-chest- .dropdown_colors .vs__actions {
   position: relative !important;
    top: 4px !important;
    background-image: url(/maincss/images/next.svg) !important;
    width: 22px;
    height: 15px;
    background-repeat: no-repeat;
    background-size: 16px;
    transform: rotate(92deg);
}
.product_details_update_v3 .left-chest- .dropdown_colors  .vs__dropdown-menu{
    top: 44px;
}

</style>